
const LOCALSTORAGE_KEY_NAME = "welleasy_onboarding_quiz_state";
const QUIZ_DOMPARSER = new DOMParser( );


function safeGetA( obj, keys )
{
    var result;
    if ( obj ) try
    {
        // sigh. must be a better way of doing this.
        if ( ( keys.length > 0 ) && ( keys[ 0 ].indexOf ) )
        {
            var arStart = keys[ 0 ].indexOf( "[" );
            if ( arStart >= 0 )
            {
                var ar       = keys.shift( );
                var numStart = arStart + 1;
                var arName   = ar.substr( 0, arStart );
                var numEnd   = ar.indexOf( "]" );
                var numStr   = ar.substr( numStart, numEnd - numStart );
                var idx      = Number( numStr );
                keys.splice( 0, 0, idx );
                if ( arStart > 0 )
                {
                    keys.splice( 0, 0, arName );
                }
            }
        }

        if ( keys.length == 1 )
        {
            result = obj[ keys[ 0 ] ];
        }
        else
        {
            var next = keys.shift( );
            if ( obj[ next ] )
            {
                result = safeGetA( obj[ next ], keys );
            }
        }
    }
    catch ( e )
    {
        logger.log( logger.LOG_WARNING, "safeGet failed : " + e.stack );
    }
    return ( result );
}
function SafeGet( obj, keys )
{
    var result;
    if ( keys )
    {
        result = safeGetA( obj, keys.split( "." ) );
    }
    else
    {
        result = obj;
    }
    return ( result );
}

function SpecialiseElement( element, data, getter )
{
    var key = element.getAttribute( "data-key" );
    if ( key )
    {
        var value = getter( data, key );
        var type  = element.getAttribute( "data-type" );
        var api   = element.getAttribute( "data-api" );
        if ( ( value == undefined ) && ( type == "html" ) )
        {
            $( element ).summernote( "code", "" );
        }
        else if ( ( value == undefined ) && ( api ) )
        {
            // another special case for dynamic elements
            // should probably refactor this function
            if ( api )
            {
                SpecialiseDynamicElement( element, value, api );
            }
        }
        else
        {
            if ( type == undefined )
            {
                type = element.type;
            }
            if ( value == undefined )
            {
                value = "";
            }

            if ( type == "id" )
            {
                element.setAttribute( "data-id", value );
            }
            else if ( type == "html" )
            {
                $( element ).summernote( "code", value );
            }
            else if ( type == "proxy" )
            {
                // ignore
            }
            else if ( ( element.tagName == "INPUT" ) || ( element.tagName == "SELECT" ) )
            {
                if ( type == "date" )
                {
                    element.value = Undateify( new Date( value ) );
                }
                else if ( ( type == "select" ) || ( element.tagName == "SELECT" ) )
                {
                    var api = element.getAttribute( "data-api" );
                    if ( api )
                    {
                        SpecialiseDynamicElement( element, value, api );
                    }
                    else
                    {
                        SetSelectedSpecialisedElement( element, value );
                    }
                }
                else if ( type == "datetime" )
                {
                    if ( element.getAttribute( "type" ) == "datetime-local" )
                    {
                        element.value = new Date( value ).toISOString( ).substr( 0, 19 );
                    }
                    else
                    {
                        element.value = new Date( value ).toLocaleString( );
                        element.setAttribute( "data-value", new Date( value ).toISOString( ) );
                    }
                }
                else if (   type == "boolean" )
                {
                    if ( value )
                    {
                        element.checked = "checked";
                    }
                }
                else
                {
                    var it = element.getAttribute( "type" );
                    if ( it == "radio" )
                    {
                        if ( value == element.value )
                        {
                            element.checked = true;
                        }
                        else
                        {
                            element.checked = false;
                        }
                    }
                    else if ( it == "checkbox" )
                    {
                        if ( value )
                        {
                            element.checked = true;
                        }
                        else
                        {
                            element.checked = false;
                        }
                    }
                    else
                    {
                        element.value = value;
                        element.setAttribute( "data-value", value ); // for some reason setting "value" is misbehaving
                    }
                }
            }
            else if ( ( element.tagName == "A" ) && ( type == "link" ) )
            {
                var hr = element.getAttribute( "href" );
                if ( hr == undefined )
                {
                    hr = "";
                }
                hr += value;
                element.setAttribute( "href", hr );
            }
            else if ( element.tagName == "IMG" )
            {
                element.setAttribute( "src", value );
            }
            else if ( element.tagName == "TEXTAREA" )
            {
                element.value = value;
            }
            else
            {
                if ( type == "price" )
                {
                    value = "\u00A3" + value;
                }
                else if ( type == "date" )
                {
                    value = Undateify( new Date( value ) );
                }

                //element.appendChild( document.createTextNode( value ) );
                element.innerText = value;
            }
            element.setAttribute( "data-value", value );
        }
    }
}

function Specialise( root, data )
{
    var dynamicElements = root.querySelectorAll( "[data-key]" );

    for ( var i = 0; i < dynamicElements.length; i++ )
    {
        var element = dynamicElements[ i ];
        SpecialiseElement( element, data, SafeGet );
    }
}

function GetQuizState( )
{
    var result   = { };
    var savedStr = window.localStorage.getItem( LOCALSTORAGE_KEY_NAME );

    if ( ( savedStr ) && ( savedStr.length > 0 ) )
    {
        try
        {
            result = JSON.parse( savedStr );
        }
        catch ( e )
        {
        }
    }
    
    return ( result );
}

function ParseQP( )
{
    var qpd   = { };
    var qp    = window.location.search.substr( 1 );
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}
function MakeQPStr( qpd )
{
    var str = "?";

    for ( var key in qpd )
    {
        if ( str.length > 1 )
        {
            str += "&";
        }
        str += encodeURIComponent( key ) + "=" + encodeURIComponent( qpd[ key ] );
    }

    return ( str );
}

// onboarding quiz version of SendAPIRequest
function OQ_SendAPIRequest( url, method, payload, cb )
{
    // there's a function called SendAPIRequest in rcp-interface.js, so can either wait for that module to be loaded
    // and available, or just duplicate the code here
    // it's probably cleaner to have a duplicate here, since that way the quiz would still work if the rcp module gets
    // removed (separation of concerns)
    // but it's defintely more maintainable - and leads to a smaller codebase - to use the existing routine, although
    // that then introduces a load-order timing issue
    // the obvious third approach is to move SendAPIRequest into some kind of global util file that's guaranteed to be
    // loaded before either rcp-interface.js or this file, but that means changing rcp as part of the quiz dev
    // which introduces additional risk and testing overhead
    
    // for now - because it's easy - just keep the load-time race conditions contained within this routine
    if ( window.SendAPIRequest )
    {
        window.SendAPIRequest( url, method, payload, cb );
    }
    else
    {
        var xhr = new XMLHttpRequest( );

        function OQ_SendAPIRequest_OnReadyStateChange( )
        {
            if ( xhr.readyState == 4 )
            {
                var response;
                var err;

                if ( xhr.status == 200 )
                {
                    if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                    {
                        try
                        {
                            response = JSON.parse( xhr.responseText );
                        }
                        catch ( e )
                        {
                            console.log( "error parsing response : " + e.stack );
                            err = { "error": e };
                        }
                    }
                }
                else
                {
                    err = { "error": xhr.status };

                    if ( ( xhr.responseText ) && ( xhr.responseText.length > 0 ) )
                    {
                        try
                        {
                            err.detail = JSON.parse( xhr.responseText );
                        }
                        catch ( e )
                        {
                        }
                    }
                }

                cb( err, response, xhr );
            }
        }

        xhr.onreadystatechange = OQ_SendAPIRequest_OnReadyStateChange;

        if ( method == "GET" )
        {
            var qpStr = "?";
            if ( payload )
            {
                qpStr = MakeQPStr( payload );
            }
            xhr.open( method, url + qpStr, true );
            xhr.send( );
        }
        else
        {
            if ( !payload )
            {
                payload = {};
            }
            xhr.open( method, url, true );
            xhr.setRequestHeader( "Content-Type", "application/json" );
            xhr.send( JSON.stringify( payload ) );
        }
    }
}

function ReallySaveOnboardingQuizState( payload, ecpayload )
{
    OQ_SendAPIRequest( window._onboardingQuizAPIRoot + "/set-custom-data", "POST", payload, function( ) { } );
    if ( ecpayload )
    {
        OQ_SendAPIRequest( "https://app.enhanced-commerce.com/api/v3/customer-data", "POST", ecpayload, function( ) { } );
    }
}

// mw 20260314 : removed all this async timer stuff because it's almost certain to go wrong and/or cause performance issues
//function SaveOnboardingQuizState_SendCallback( err, result )
//{
//}

//function SaveOnboardingQuizState_RunSave( payload, ecpayload )
//{
//    if ( !window.SendAPIRequest ) { return false; }
//    SendAPIRequest( window._onboardingQuizAPIRoot + "/set-custom-data", "POST", payload, SaveOnboardingQuizState_SendCallback );
//    if ( ecpayload )
//    {
//        SendAPIRequest( "https://app.enhanced-commerce.com/api/v3/customer-data", "POST", ecpayload, SaveOnboardingQuizState_SendCallback );
//    }
//    return true;
//}
//
//function SaveOnboardingQuizState_PollTick( payload, ecpayload, intervalRef, attemptsRef, maxAttempts )
//{
//    attemptsRef[ 0 ]++;
//    if ( SaveOnboardingQuizState_RunSave( payload, ecpayload ) || attemptsRef[ 0 ] >= maxAttempts )
//    {
//        clearInterval( intervalRef[ 0 ] );
//    }
//}

function FetchCollectionsFromShopify( collectionHandles, cb )
{
    var collections = [];

    window._onboardingMappingCollections = window._onboardingMappingCollections || {};
    
    function GetOneCollection( idx )
    {
        if( idx < collectionHandles.length )
        {
            var handle      = collectionHandles[ idx ];
            var allProducts = [];
            var payload     = {
                limit: 200
            }

            if( window._onboardingMappingCollections[ handle ] )
            {
                collections.push( window._onboardingMappingCollections[ handle ] );
                GetOneCollection( idx + 1 );
            }
            else
            {
                function FetchPage( pageNum )
                {
                    payload.page = pageNum;
                    OQ_SendAPIRequest( 
                        window.location.origin + '/collections/' + handle + '/products.json', 
                        'GET', 
                        payload, 
                        function( error, data )
                        {
                            if( data && data.products )
                            {
                                allProducts = allProducts.concat( data.products );
                                if( data.products.length == 200 )
                                {
                                    FetchPage( pageNum + 1 );
                                }
                                else
                                {
                                    collections.push( allProducts.map( function( product ) { return product.id; } ) );
                                    window._onboardingMappingCollections[ handle ] = collections[ collections.length - 1 ];
                                    GetOneCollection( idx + 1 );
                                }
                            }
                            else
                            {
                                console.error( 'Failed to fetch collection ' + handle + ': ' + error );
                                GetOneCollection( idx + 1 );
                            }
                        }
                    );
                }
                
                FetchPage( 1 );
            }
        }
        else
        {
            cb( collections );
        }
    }
    
    if( window.SendAPIRequest )
    {
        GetOneCollection( 0 );
    }
}

function IsAnswerInState( stateValues, answerValue )
{
    var i;
    var found = false;
    if ( stateValues && Array.isArray( stateValues ) )
    {
        for ( i = 0; i < stateValues.length; i++ )
        {
            if ( stateValues[ i ] == answerValue || stateValues[ i ].indexOf( answerValue + ":" ) == 0 )
            {
                found = true;
                break;
            }
        }
    }
    return found;
}

function HandleProductMapping( state, ecpayload, slides )
{
    ecpayload.data.inclusiveProductTags = ecpayload.data.inclusiveProductTags || { };
    ecpayload.data.collectionProducts   = ecpayload.data.collectionProducts || { };
    ecpayload.data.collectionHandles    = ecpayload.data.collectionHandles || { };
    ecpayload.data.vendors              = ecpayload.data.vendors || { };

    if ( state.peopleCount && state.peopleCount.length > 0 )
    {
        var people      = Number( state.peopleCount[ 0 ] );
        var targets     = window._onboardingQuizData.peopleCountTargets;
        var targetValue = targets[ String( people ) ];
        if ( targetValue != null )
        {
            ecpayload.data.targetValue = targetValue;
        }
    }

    if ( state.brands )
    {
        state.brands.forEach( function( brand )
        {
            ecpayload.data.vendors[ brand.toLowerCase( ) ] = 1;
        } );
    }

    var collectionHandles = [];

    function HandleProductMappingSlide( slide )
    {
        function HandleProductMappingAnswer( answer )
        {
            var tag = answer.productTag && answer.productTag.trim ? answer.productTag.trim() : ( answer.productTag || "" );
            if ( tag.length > 0 && IsAnswerInState( state[ slide.key ], answer.value ) && ecpayload.data.inclusiveProductTags[ tag ] == null )
            {
                ecpayload.data.inclusiveProductTags[ tag ] = "2";
            }
            else if( answer.productCollection && answer.productCollection.length > 0 )
            {
                for ( var key in state )
                {
                    if ( state[ key ].includes( answer.value ) )
                    {
                        collectionHandles.push( answer.productCollection );
                        ecpayload.data.collectionHandles[ answer.productCollection ] = true;
                    }
                }
            }
        }

        if( slide.slideType == "Question" )
        {
            var answers = slide.answers;
            if( answers.length > 0 )
            {
                answers.forEach( HandleProductMappingAnswer );
            }
        }
    }

    slides.forEach( HandleProductMappingSlide );

    // mw 20260223 : disabled the below for now, it's not working properly...
    //FetchCollectionsFromShopify( collectionHandles, function( collections )
    //{
    //    var productIdCounts = {};
    //    
    //    collections.forEach( function( productIds ) {
    //        productIds.forEach( function( productId ) {
    //            productIdCounts[ productId ] = ( productIdCounts[ productId ] || 0 ) + 1;
    //        });
    //    });
    //    
    //    var sortedEntries = Object.entries( productIdCounts ).sort( function( a, b )
    //    {
    //        return b[ 1 ] - a[ 1 ];
    //    });
    //
    //    ecpayload.collectionProducts = sortedEntries;
    //    console.log( "Sorted Entries: ", sortedEntries );
    //});

    return ecpayload;
}

// send state to the API if logged in (defers until SendAPIRequest is available)
function SaveOnboardingQuizState( )
{
    var quiz       = null;
    var state      = null;
    var payload    = null;
    var ecpayload  = null;
    var i          = 0;
    var entry      = null;
    var parts      = null;
    var levelStr   = null;
    var levelParts = null;
    var diet       = null;
    var attempts   = [ 0 ];
    var intervalRef = [ null ];

    if ( window._onboardingQuizData.auth )
    {
        quiz       = document.querySelector( ".we-onboarding-quiz" );
        state      = GetQuizState( );
        payload    = { "onboardingQuizAnswers" : state, "auth" : window._onboardingQuizData.auth };

        if ( state.diets && state.diets.length > 0 )
        {
            ecpayload = { "auth" : window._onboardingQuizData.auth, "data" : { "inclusiveProductTags" : { }, "collectionProducts" : { } } };
            for ( i = 0; i < state.diets.length; i++ )
            {
                entry      = state.diets[ i ];
                parts      = entry.split( ":" );
                if ( parts.length == 2 )
                {
                    levelStr   = parts[ 1 ];
                    levelParts = levelStr.split( "-" );
                    if ( levelParts.length == 2 )
                    {
                        diet = parts[ 0 ].trim( );
                        if ( ecpayload.data.inclusiveProductTags[ diet ] == null )
                        {
                            ecpayload.data.inclusiveProductTags[ diet ] = levelParts[ 1 ];
                        }
                    }
                }
            }
        }
        if ( !ecpayload )
        {
            ecpayload = { "auth" : window._onboardingQuizData.auth, "data" : { "inclusiveProductTags" : { }, "collectionProducts" : { }, "collectionHandles" : { } } };
        }
        ecpayload = HandleProductMapping( state, ecpayload, window._onboardingQuizData.slides );

        ReallySaveOnboardingQuizState( payload, ecpayload );

        // mw 20260314 : removed all this async timer stuff because it's almost certain to go wrong and/or cause performance issues
        //if ( !SaveOnboardingQuizState_RunSave( payload, ecpayload ) )
        //{
        //    intervalRef[ 0 ] = setInterval( SaveOnboardingQuizState_Interval, 100 );
        //}

        //function SaveOnboardingQuizState_Interval( )
        //{
        //    SaveOnboardingQuizState_PollTick( payload, ecpayload, intervalRef, attempts, 100 );
        //}
    }
}

// save the current answers to localstorage
function SaveOnboardingQuizAnswers( )
{
    var quiz             = document.querySelector( ".we-onboarding-quiz" );
    var qidx             = Number( quiz.getAttribute( "data-idx" ) );
    var slide            = window._onboardingQuizData.slides[ qidx ];
    var data             = GetQuizState( );
    var answersContainer = quiz.querySelector( ".we-onboarding-quiz-answers" );
    var selected         = answersContainer.querySelectorAll( ".we-onboarding-quiz-selected-answer" );
    var toSet            = [ ];

    function CollectSelectedAnswer( selection )
    {
        // if answer has additional options, append to the value
        // if option is somehow null, don't add the answer at all
        if ( selection._answerData.selectedOption && selection._answerData.selectedOption != null )
        {
            toSet.push( selection._answerData.value + ":" + selection._answerData.selectedOption );
        }
        else if ( !selection._answerData.selectedOption )
        {
            toSet.push( selection._answerData.value );
        }
    }
    selected.forEach( CollectSelectedAnswer );
    
    data[ slide.key ] = toSet;

    window.localStorage.setItem( LOCALSTORAGE_KEY_NAME, JSON.stringify( data ) );
}


function AnswerClicked( e )
{
    var answer = e.currentTarget;
    var quiz   = answer.closest( ".we-onboarding-quiz" );
    var qidx   = Number( quiz.getAttribute( "data-idx" ) );
    var slide  = window._onboardingQuizData.slides[ qidx ];

    if ( slide.answerType == "Single" )
    {
        if ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) )
        {
            answer.classList.remove( "we-onboarding-quiz-selected-answer" );
            CloseOptionsPopup( );
        }
        else
        {
            var answers = answer.closest( ".we-onboarding-quiz-answers" ).querySelectorAll( ".we-onboarding-quiz-answer" );
            function ToggleSingleAnswer( toCheck )
            {
                if ( toCheck == answer )
                {
                    toCheck.classList.add( "we-onboarding-quiz-selected-answer" );
                }
                else
                {
                    toCheck.classList.remove( "we-onboarding-quiz-selected-answer" );
                }
            }
            answers.forEach( ToggleSingleAnswer );
        }
    }
    else
    {
        answer.classList.toggle( "we-onboarding-quiz-selected-answer" );

        var answers = answer.closest( ".we-onboarding-quiz-answers" ).querySelectorAll( ".we-onboarding-quiz-answer" );
        function ToggleMultipleAnswer( toCheck )
        {
            if ( answer._answerData.none )
            {
                if ( ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) ) && ( answer != toCheck ) )
                {
                    toCheck.classList.remove( "we-onboarding-quiz-selected-answer" );
                }
            }
            else if ( ( toCheck._answerData.none ) && ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) ) )
            {
                toCheck.classList.remove( "we-onboarding-quiz-selected-answer" );
            }
        }
        answers.forEach( ToggleMultipleAnswer );
    }

    // const cardContent = answer.querySelector( ".we-onboarding-quiz-answer-card-content" );
    // const desc = cardContent ? cardContent.querySelector( ".we-onboarding-quiz-answer-description" ) : answer.querySelector( ".we-onboarding-quiz-answer-description" );
    // if ( desc )
    // {
    //     requestAnimationFrame( function( )
    //     {
    //         if ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) )
    //         {
    //             desc.style.maxHeight = "500px";
    //             desc.style.padding = "12px 16px";
    //             desc.style.transform = "translateX(0)";
    //             desc.style.opacity = "1";
    //         }
    //         else
    //         {
    //             desc.style.maxHeight = "0";
    //             desc.style.padding = "0 16px";
    //             desc.style.transform = "translateX(-15px)";
    //             desc.style.opacity = "0";
    //         }
    //     } );
    // }
    
    if ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) )
    {
        quiz.querySelector( ".we-onboarding-quiz-error-prompt" ).classList.add( "hidden" );
    }

    // show additional options if answer has been selected and has options
    var shouldShowOptions = false;
    var optionsData = null;
    
    if ( answer.classList.contains( "we-onboarding-quiz-selected-answer" ) )
    {
        if ( answer._answerData.optionsQuestion != "" && answer._answerData.options.length > 0 )
        {
            shouldShowOptions = true;
            optionsData = answer._answerData;
        }
        else if ( !answer._answerData.none )
        {
            const allAnswers = answer.closest( ".we-onboarding-quiz-answers" ).querySelectorAll( ".we-onboarding-quiz-answer" );
            var answerWithOptions = null;
            for ( var i = 0; i < allAnswers.length; i++ )
            {
                if ( allAnswers[ i ]._answerData.optionsQuestion != "" && allAnswers[ i ]._answerData.options.length > 0 )
                {
                    answerWithOptions = allAnswers[ i ]._answerData;
                    break;
                }
            }
            
            if ( answerWithOptions )
            {
                shouldShowOptions = true;
                optionsData = {
                    optionsQuestion: "How strictly do you follow " + answer._answerData.text + "?",
                    options: answerWithOptions.options
                };
            }
        }
    }
    
    if ( shouldShowOptions && optionsData )
    {
        ShowAnswerOptions( optionsData, answer );
    }
    else
    {
        SaveOnboardingQuizAnswers( );
    }
}

function GetQuizProgress( currentIdx )
{
    const currentSlide = window._onboardingQuizData.slides[ currentIdx ];
    function IsQuestionSlide( slide )
    {
        return slide.slideType == "Question";
    }
    const slides = window._onboardingQuizData.slides.filter( IsQuestionSlide );
    if ( slides.length > 0 )
    {
        function MatchesCurrentSlidePosition( slide )
        {
            return slide.position == currentSlide.position;
        }
        var slideIndex = slides.findIndex( MatchesCurrentSlidePosition );
        if ( slideIndex != -1 )
        {
            return {
                currentQuestion: slideIndex + 1,
                max: slides.length
            }
        }
    }
    return null;
}

function ResetInterstitialProgressBar( )
{
    var inner = document.querySelector( ".we-onboarding-quiz-interstitial-progress-bar-inner" );

    if ( inner )
    {
        inner.style.transition = "none";
        inner.style.width      = "0%";
    }
}

function AnimateInterstitialProgressBar( durationMs )
{
    var inner = document.querySelector( ".we-onboarding-quiz-interstitial-progress-bar-inner" );
    var ms    = Number( durationMs || 0 );

    if ( inner )
    {
        if ( Number.isFinite( ms ) && ms > 0 )
        {
            inner.style.transition = "none";
            inner.style.width      = "0%";
            inner.offsetHeight;
            inner.style.transition = "width " + ms + "ms linear";
            inner.style.width      = "100%";
        }
        else
        {
            inner.style.transition = "none";
            inner.style.width      = "0%";
        }
    }
}

function UpdateStepIcon( step, state )
{
    var iconContainer = step.querySelector( ".we-onboarding-quiz-results-loading-step-icon" );
    var circleIcon    = null;
    var sparkleIcon   = null;
    var checkIcon     = null;

    if ( iconContainer )
    {
        circleIcon  = iconContainer.querySelector( ".we-onboarding-quiz-results-loading-step-icon-circle" );
        sparkleIcon  = iconContainer.querySelector( ".we-onboarding-quiz-results-loading-step-icon-sparkle" );
        checkIcon    = iconContainer.querySelector( ".we-onboarding-quiz-results-loading-step-icon-check" );

    if ( state == "pending" )
    {
        if ( circleIcon )
        {
            circleIcon.style.display = "block";
        }
        if ( sparkleIcon )
        {
            sparkleIcon.style.display = "none";
        }
        if ( checkIcon )
        {
            checkIcon.style.display = "none";
        }
    }
    else if ( state == "active" )
    {
        if ( circleIcon )
        {
            circleIcon.style.display = "none";
        }
        if ( sparkleIcon )
        {
            sparkleIcon.style.display = "block";
        }
        if ( checkIcon )
        {
            checkIcon.style.display = "none";
        }
    }
    else if ( state == "completed" )
    {
        if ( circleIcon )
        {
            circleIcon.style.display = "none";
        }
        if ( sparkleIcon )
        {
            sparkleIcon.style.display = "none";
        }
        if ( checkIcon )
        {
            checkIcon.style.display = "block";
        }
    }
    }
}

function UpdateProgressBarState( activeStepIndex )
{
    const progressBars = document.querySelectorAll( ".we-onboarding-quiz-results-progress-bar" );
    
    function ProcessProgressBar( progressBar )
    {
        const steps = progressBar.querySelectorAll( ".we-onboarding-quiz-results-progress-step" );
        const filledLine = progressBar.querySelector( ".we-onboarding-quiz-results-progress-line-filled" );
        
        if ( steps && steps.length >= 3 )
        {
        function ProcessStep( step, index )
        {
            step.classList.remove( "we-onboarding-quiz-results-progress-step--completed", "we-onboarding-quiz-results-progress-step--active" );
            
            const circle = step.querySelector( ".we-onboarding-quiz-results-progress-step-circle" );
            const box = step.querySelector( ".we-onboarding-quiz-results-progress-step-box" );
            const sparkle = step.querySelector( ".we-onboarding-quiz-results-progress-step-sparkle" );
            const label = step.querySelector( ".we-onboarding-quiz-results-progress-step-label" );
            
            if ( index < activeStepIndex )
            {
                step.classList.add( "we-onboarding-quiz-results-progress-step--completed" );
                if ( circle )
                {
                    circle.classList.remove( "we-onboarding-quiz-results-progress-step-circle--pending" );
                    circle.style.display = "block";
                }
                if ( box )
                {
                    box.style.display = "none";
                }
                if ( sparkle )
                {
                    sparkle.style.display = "none";
                }
                if ( label )
                {
                    label.classList.remove( "we-onboarding-quiz-results-progress-step-label--pending" );
                }
            }
            else if ( index == activeStepIndex )
            {
                step.classList.add( "we-onboarding-quiz-results-progress-step--active" );
                if ( index == 1 )
                {
                    if ( box )
                    {
                        box.style.display = "block";
                    }
                    if ( sparkle )
                    {
                        sparkle.style.display = "block";
                    }
                    if ( circle )
                    {
                        if ( box )
                        {
                            circle.style.display = "none";
                        }
                        else
                        {
                            circle.classList.remove( "we-onboarding-quiz-results-progress-step-circle--pending" );
                            circle.style.display = "block";
                        }
                    }
                }
                else
                {
                    if ( circle )
                    {
                        circle.classList.remove( "we-onboarding-quiz-results-progress-step-circle--pending" );
                        circle.style.display = "block";
                    }
                    if ( box )
                    {
                        box.style.display = "none";
                    }
                    if ( sparkle )
                    {
                        sparkle.style.display = "none";
                    }
                }
                if ( label )
                {
                    label.classList.remove( "we-onboarding-quiz-results-progress-step-label--pending" );
                }
            }
            else
            {
                if ( circle )
                {
                    circle.classList.add( "we-onboarding-quiz-results-progress-step-circle--pending" );
                    circle.style.display = "block";
                }
                if ( box )
                {
                    box.style.display = "none";
                }
                if ( sparkle )
                {
                    sparkle.style.display = "none";
                }
                if ( label )
                {
                    label.classList.add( "we-onboarding-quiz-results-progress-step-label--pending" );
                }
            }
        }
        
        steps.forEach( ProcessStep );
        
        if ( filledLine )
        {
            const widthPercent = ( activeStepIndex / 2 ) * 100;
            filledLine.style.width = widthPercent + "%";
        }
        }
    }
    
    progressBars.forEach( ProcessProgressBar );
}

function AnimateResultsLoadingProgress( slideData )
{
    var progressBar = document.querySelector( ".we-onboarding-quiz-results-loading-progress-bar-inner" );
    var progressCart = document.querySelector( ".we-onboarding-quiz-results-loading-progress-cart" );
    var steps = document.querySelectorAll( ".we-onboarding-quiz-results-loading-step" );
    var completionEl = document.querySelector( ".we-onboarding-quiz-results-loading-progress-amount" );

    if ( progressBar && progressCart && steps && steps.length >= 4 )
    {
        function InitializeLoadingStep( step )
        {
            step.classList.remove( "we-onboarding-quiz-results-loading-step--completed", "we-onboarding-quiz-results-loading-step--active", "we-onboarding-quiz-results-loading-step--pending" );
            step.classList.add( "we-onboarding-quiz-results-loading-step--pending" );
            UpdateStepIcon( step, "pending" );
        }

        steps.forEach( InitializeLoadingStep );

        progressBar.style.transition = "none";
        progressBar.style.width = "0%";
        progressCart.style.transition = "none";
        progressCart.style.left = "0%";

        progressBar.offsetHeight;

        var totalDuration = slideData.autoadvanceTime || 8000;
        var stepDuration = totalDuration / 4;

        progressBar.style.transition = "width " + totalDuration + "ms linear";
        progressBar.style.width = "100%";
        progressCart.style.transition = "left " + totalDuration + "ms linear";
        progressCart.style.left = "100%";

        function ActivateStepZero( )
        {
            steps[ 0 ].classList.remove( "we-onboarding-quiz-results-loading-step--pending" );
            steps[ 0 ].classList.add( "we-onboarding-quiz-results-loading-step--active" );
            UpdateStepIcon( steps[ 0 ], "active" );
        }

        function CompleteStepAndActivateNext( completedIdx, activateIdx )
        {
            steps[ completedIdx ].classList.remove( "we-onboarding-quiz-results-loading-step--active" );
            steps[ completedIdx ].classList.add( "we-onboarding-quiz-results-loading-step--completed" );
            UpdateStepIcon( steps[ completedIdx ], "completed" );

            steps[ activateIdx ].classList.remove( "we-onboarding-quiz-results-loading-step--pending" );
            steps[ activateIdx ].classList.add( "we-onboarding-quiz-results-loading-step--active" );
            UpdateStepIcon( steps[ activateIdx ], "active" );
        }

        function CompleteLastStep( )
        {
            steps[ 3 ].classList.remove( "we-onboarding-quiz-results-loading-step--active" );
            steps[ 3 ].classList.add( "we-onboarding-quiz-results-loading-step--completed" );
            UpdateStepIcon( steps[ 3 ], "completed" );
        }

        function WE_OnResultsLoadingTimerAnimationEnd( e )
        {
            var target = e.currentTarget;
            var tickType = target.getAttribute( "data-we-results-loading-tick" ) || "";

            if ( tickType == "t1" )
            {
                CompleteStepAndActivateNext( 0, 1 );
                if ( completionEl )
                {
                    completionEl.innerText = 25;
                }
            }
            else if ( tickType == "t2" )
            {
                CompleteStepAndActivateNext( 1, 2 );
                if ( completionEl )
                {
                    completionEl.innerText = 50;
                }
            }
            else if ( tickType == "t3" )
            {
                CompleteStepAndActivateNext( 2, 3 );
                if ( completionEl )
                {
                    completionEl.innerText = 75;
                }
            }
            else if ( tickType == "t4" )
            {
                CompleteLastStep( );
                if ( completionEl )
                {
                    completionEl.innerText = 100;
                }
            }

            if ( target && target.parentNode )
            {
                target.parentNode.removeChild( target );
            }
        }

        ActivateStepZero( );

        var loadingEl = progressBar.closest( ".we-onboarding-quiz-results-loading" ) || progressBar;
        if ( completionEl )
        {
            completionEl.innerText = 0;
        }

        function CreateLoadingTimerElement( tickType, delayMs )
        {
            var el = document.createElement( "div" );
            el.setAttribute( "class", "we-onboarding-quiz-results-loading-step-timer" );
            el.setAttribute( "data-we-results-loading-tick", tickType );
            el.style.animation = "we-onboarding-quiz-results-loading-tick 1ms linear both";
            el.style.animationDelay = delayMs + "ms";
            el.addEventListener( "animationend", WE_OnResultsLoadingTimerAnimationEnd );
            loadingEl.appendChild( el );
        }

        CreateLoadingTimerElement( "t1", stepDuration );
        CreateLoadingTimerElement( "t2", stepDuration * 2 );
        CreateLoadingTimerElement( "t3", stepDuration * 3 );
        CreateLoadingTimerElement( "t4", totalDuration );
    }
}


function ShowSlide( idx, firstLoad )
{
    var skipRegisterRedirect = false;
    try { skipRegisterRedirect = ( sessionStorage.getItem( "cta_quiz_show_results" ) == "1" ); } catch ( e ) {}
    if ( skipRegisterRedirect )
    {
        try { sessionStorage.removeItem( "cta_quiz_show_results" ); } catch ( e ) {}
    }
    if ( window._onboardingQuizData && window._onboardingQuizData.createAccountSlide == idx && !localStorage.getItem( "quiz_account_creation" ) && !skipRegisterRedirect && !sessionStorage.getItem( "quiz_logged_in_skip_register" ) )
    {
        if ( window._onboardingQuizData.auth )
        {
            try { sessionStorage.setItem( "quiz_logged_in_skip_register", "1" ); } catch ( e ) {}
            window.location.href = "/pages/welleasy-quiz?slide=16";
        }
        else
        {
            localStorage.setItem( "quiz_account_creation", true );
            try { sessionStorage.setItem( "we_register_flow", "quiz" ); } catch ( e ) {}
            window.location.href = "/account/register";
        }
    }

    var slideData          = window._onboardingQuizData.slides[ idx ];
    var quiz               = document.querySelector( ".we-onboarding-quiz" );
    var answers            = null;
    var data               = null;
    var quizProgress       = null;
    var quizProgressEl     = null;
    var quizProgressInner  = null;
    var interstitialBodyEl = null;
    
    if ( quiz && slideData )
    {
    answers            = quiz.querySelector( ".we-onboarding-quiz-answers" );
    data               = GetQuizState( );
    quizProgress       = GetQuizProgress( idx );
    quizProgressEl     = quiz.querySelector( ".we-onboarding-quiz-progress" );
    quizProgressInner  = quiz.querySelector( ".we-onboarding-quiz-progressbar-inner" );
    interstitialBodyEl = quiz.querySelector( ".we-onboarding-quiz-interstitial-body" );

    if ( answers )
    {
        while ( answers.firstChild )
        {
            answers.firstChild.remove( );
        }
    }

    if ( slideData.slideType == "Question" )
    {
        if ( slideData.answerType == "Multiple" )
        {
            quiz.querySelector( ".we-onboarding-quiz-question-type-prompt" ).classList.remove( "hidden" );
        }
        else
        {
            quiz.querySelector( ".we-onboarding-quiz-question-type-prompt" ).classList.add( "hidden" );
        }
        
        if ( slideData.answers && slideData.answers.length > 5 )
        {
            answers.classList.remove( "we-onboarding-quiz-stacked-answers" );
            answers.classList.add( "we-onboarding-quiz-grid-answers" );
        }
        else
        {
            answers.classList.add( "we-onboarding-quiz-stacked-answers" );
            answers.classList.remove( "we-onboarding-quiz-grid-answers" )
        }
    }

    var firstSlidePosition = window._onboardingQuizData.slides.length > 0 ? 
        parseInt( window._onboardingQuizData.slides[ 0 ].position, 10 ) : null;
    var currentSlidePosition = parseInt( slideData.position, 10 );
    
    var prevBtns = quiz.querySelectorAll( ".we-onboarding-quiz-prev" );
    if ( !isNaN( firstSlidePosition ) && !isNaN( currentSlidePosition ) && 
         currentSlidePosition == firstSlidePosition )
    {
        prevBtns.forEach( function addDisabledToPrevBtn( btn ) { btn.classList.add( "disabled" ); } );
    }
    else
    {
        prevBtns.forEach( function removeDisabledFromPrevBtn( btn ) { btn.classList.remove( "disabled" ); } );
    }

    quiz.setAttribute( "data-idx", idx );
    
    var interstitialBody = slideData.interstitialBody;
    
    if ( slideData.slideType == "Interstitial" && slideData.interstitialBody != "" )
    {
        interstitialBody = QUIZ_DOMPARSER.parseFromString( interstitialBody, "text/html" );
        var metafieldEl              = interstitialBody.body.querySelector( ".metafield-rich_text_field" );
        if ( metafieldEl )
        {
            interstitialBodyEl.innerHTML = metafieldEl.innerHTML;
        }
    }
    
    Specialise( quiz, slideData );
    
    if ( slideData.slideType == "CustomPicked" && slideData.interstitialBody != "" )
    {
        var customPickedSubtitle = quiz.querySelector( ".we-onboarding-quiz-custom-picked-subtitle" );
        if ( customPickedSubtitle )
        {
            interstitialBody = QUIZ_DOMPARSER.parseFromString( slideData.interstitialBody, "text/html" );
            var metafieldEl              = interstitialBody.body.querySelector( ".metafield-rich_text_field" );
            if ( metafieldEl )
            {
                customPickedSubtitle.innerHTML = metafieldEl.innerHTML;
            }
            else
            {
                customPickedSubtitle.textContent = slideData.interstitialBody.replace( /<[^>]*>/g, "" );
            }
        }
    }

    if ( quizProgress )
    {
        quizProgressEl.innerHTML = quizProgress.currentQuestion + " of " + quizProgress.max;
        quizProgressInner.setAttribute( "style", "width: " + ( quizProgress.currentQuestion / quizProgress.max * 100 ) + "%" )
    }

    if ( slideData.slideType == "Welcome" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container ) { container.classList.add( "hidden" ); } );
        
        const welcomeBodyEl = quiz.querySelector( ".we-onboarding-quiz-welcome-body" );
        if ( welcomeBodyEl && slideData.welcomeBody && slideData.welcomeBody.trim() != "" )
        {
            var welcomeBody = QUIZ_DOMPARSER.parseFromString( slideData.welcomeBody, "text/html" );
            metafieldEl = welcomeBody.body.querySelector( ".metafield-rich_text_field" );
            welcomeBodyEl.innerHTML = metafieldEl.innerHTML;
            welcomeBodyEl.style.display = "block";
        }
        else if ( welcomeBodyEl && ( !slideData.welcomeBody || slideData.welcomeBody.trim() == "" ) )
        {
            welcomeBodyEl.style.display = "block";
        }
        
        const discoverBtn = quiz.querySelector( ".we-onboarding-quiz-welcome-discover" );
        const skipBtn = quiz.querySelector( ".we-onboarding-quiz-welcome-skip" );
        
        if ( discoverBtn )
        {
            discoverBtn.onclick = function( )
            {
                NextOnboardingSlide( );
            };
        }
        
        if ( skipBtn )
        {
            skipBtn.onclick = function( )
            {
                window.location.href = "/";
            };
        }
    }
    else if ( slideData.slideType == "Question" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.remove( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function removeHiddenFromContainer( container ) { container.classList.remove( "hidden" ); } );
        answers.classList.remove( "hidden" );

        ResetInterstitialProgressBar( );
    }
    else if ( slideData.slideType == "CustomCreating" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container ) { container.classList.add( "hidden" ); } );

        if ( idx == 20 )
        {
            UpdateProgressBarState( 2 );
            const customCreatingTitle = quiz.querySelector( ".we-onboarding-quiz-custom-creating-title" );
            const customCreatingDots = quiz.querySelector( ".we-onboarding-quiz-custom-creating-dots" );
            const customCreatingSubtitle = quiz.querySelector( ".we-onboarding-quiz-custom-creating-subtitle" );
            
            if ( customCreatingTitle )
            {
                customCreatingTitle.textContent = "We've found 100+ products we think you'll love";
            }
            
            if ( customCreatingDots )
            {
                customCreatingDots.style.display = "none";
            }
            
            if ( !customCreatingSubtitle )
            {
                const subtitle = document.createElement( "p" );
                subtitle.className = "we-onboarding-quiz-custom-creating-subtitle";
                subtitle.textContent = "Feel free to add them into your order too";
                if ( customCreatingTitle && customCreatingTitle.parentNode )
                {
                    customCreatingTitle.parentNode.insertBefore( subtitle, customCreatingTitle.nextSibling );
                }
            }
            else
            {
                customCreatingSubtitle.textContent = "Feel free to add them into your order too";
                customCreatingSubtitle.style.display = "block";
            }
        }
        else
        {
            UpdateProgressBarState( 1 );
            const customCreatingDots = quiz.querySelector( ".we-onboarding-quiz-custom-creating-dots" );
            const customCreatingSubtitle = quiz.querySelector( ".we-onboarding-quiz-custom-creating-subtitle" );
            
            if ( customCreatingDots )
            {
                customCreatingDots.style.display = "flex";
            }
            
            if ( customCreatingSubtitle )
            {
                customCreatingSubtitle.style.display = "none";
            }
        }

        if ( slideData.interstitialBody != "" )
        {
            var bodyEl           = quiz.querySelector( ".we-onboarding-quiz-custom-creating-body" );
            var interstitialBody = slideData.interstitialBody;
            interstitialBody     = QUIZ_DOMPARSER.parseFromString( interstitialBody, "text/html" );
            var metafieldEl      = interstitialBody.body.querySelector( ".metafield-rich_text_field" );
            if ( metafieldEl )
            {
                bodyEl.innerHTML = metafieldEl.innerHTML;
            }
        }
        else
        {
            var bodyEl       = quiz.querySelector( ".we-onboarding-quiz-custom-creating-body" );
            bodyEl.innerHTML = "";
        }

        AnimateInterstitialProgressBar( slideData.autoadvanceTime );
        var productsElEarly = quiz.querySelector( ".we-onboarding-quiz-results-products" );
        if ( productsElEarly && !productsElEarly.querySelector( ".enhanced-commerce-widget" ) )
        {
            // mw 20260322 : remove DOM cache, it was supposed to be a network cache
            //var didRestoreEarly = WE_QuizResults_RestoreProductsDomCache( productsElEarly );
            //if ( didRestoreEarly )
            //{
            //    WE_QuizResults_LoadWidget( productsElEarly );
            //}
            //else
            {
                WE_QuizResults_ScheduleResultsWidget( productsElEarly, 0 );
            }
        }
    }
    else if ( slideData.slideType == "CustomPicked" )
    {
        var productsElPicked = null;
        var didRestorePicked = false;

        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container ) { container.classList.add( "hidden" ); } );

        productsElPicked = quiz.querySelector( ".we-onboarding-quiz-results-products" );
        if ( productsElPicked )
        {
            // mw 20260322 : remove DOM cache, it was supposed to be a network cache
            //didRestorePicked = WE_QuizResults_RestoreProductsDomCache( productsElPicked );

            if ( didRestorePicked )
            {
                WE_QuizResults_LoadWidget( productsElPicked );
            }
            else if ( !productsElPicked.querySelector( ".enhanced-commerce-widget" ) )
            {
                WE_QuizResults_ScheduleResultsWidget( productsElPicked, 0 );
            }
        }

        WE_QuizResults_PopulatePlaceholderImages( );

        AnimateInterstitialProgressBar( slideData.autoadvanceTime );
    }
    else if ( slideData.slideType == "ResultsLoading" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container ) { container.classList.add( "hidden" ); } );

        AnimateResultsLoadingProgress( slideData );
        var completionEl       = quiz.querySelector( ".we-onboarding-quiz-results-loading-progress-amount" );
        completionEl.innerText = 0;

        var progressBar = quiz.querySelector( ".we-onboarding-quiz-results-loading-progress-bar-inner" );
        if ( progressBar )
        {
            function WE_OnboardingQuizResultsLoading_HandleTransitionEnd( e )
            {
                if ( e.propertyName == "width" )
                {
                    progressBar.removeEventListener( "transitionend", WE_OnboardingQuizResultsLoading_HandleTransitionEnd );
                    completionEl.innerText = 100;
                    if ( idx + 1 < window._onboardingQuizData.slides.length )
                    {
                        ShowSlide( idx + 1 );
                    }
                }
            }

            progressBar.addEventListener( "transitionend", WE_OnboardingQuizResultsLoading_HandleTransitionEnd );
        }
        else
        {
            completionEl.innerText = 100;
            if ( idx + 1 < window._onboardingQuizData.slides.length )
            {
                ShowSlide( idx + 1 );
            }
        }
    }
    else if ( slideData.slideType == "Results" )
    {
        var productsEl  = quiz.querySelector( ".we-onboarding-quiz-results-products" );
        var delayMs    = 0;
        var didRestore = false;

        /* Hide products and clear widget before showing results section to prevent flash of content */
        if ( productsEl )
        {
            productsEl.classList.remove( "we-onboarding-quiz-results-products--visible" );
            
            /* Allow reveal only after delay so widget cannot show before we intend */
            // mw 20260322 : remove DOM cache, it was supposed to be a network cache
            //didRestore = WE_QuizResults_RestoreProductsDomCache( productsEl );
            //if ( didRestore )
            //{
            //    WE_QuizResults_LoadWidget( productsEl );
            //}

            // mw 20260322 : why is this hardcoded to 1.4 seconds ? Simplifying...
            //productsEl._weQuizResultsRevealAt = Date.now( ) + 1400;
            //requestAnimationFrame( WE_QuizResults_RevealProductsContainerTick );

            function WE_OnResultsProductsTransitionEnd( e )
            {
                if ( e && ( e.propertyName == "opacity" ) )
                {
                    WE_QuizResults_WaitForCardsThenEnhance( productsEl, 0 );
                    productsEl.style.transitionDelay = "";
                    productsEl.removeEventListener( "transitionend", WE_OnResultsProductsTransitionEnd );
                }
            }

            productsEl.style.transitionDelay = "1400ms";
            productsEl.addEventListener( "transitionend", WE_OnResultsProductsTransitionEnd );
            productsEl.classList.add( "we-onboarding-quiz-results-products--visible" );
            WE_QuizResults_WaitForCardsThenEnhance( productsEl, 0 );
        }

        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container ) { container.classList.add( "hidden" ); } );
        
        const resultsTitle = quiz.querySelector( ".we-onboarding-quiz-results-title" );
        const resultsSubtitle = quiz.querySelector( ".we-onboarding-quiz-results-subtitle" );
        const resultsInstructions = quiz.querySelector( ".we-onboarding-quiz-results-instructions" );
        
        if ( resultsTitle && ( !resultsTitle.textContent || resultsTitle.textContent.trim() == "" ) )
        {
            resultsTitle.textContent = "Your healthy shop is ready";
        }
        
        if ( resultsSubtitle && ( !resultsSubtitle.textContent || resultsSubtitle.textContent.trim() == "" ) )
        {
            resultsSubtitle.textContent = "Built from your answers on taste, values, dietary needs & everyday habits";
        }
        
        if ( resultsInstructions && ( !resultsInstructions.textContent || resultsInstructions.textContent.trim() == "" ) )
        {
            resultsInstructions.textContent = "You're in control — keep what you love, remove anything you don't. Finalise your order next.";
        }
        
        if ( idx >= 21 )
        {
            UpdateProgressBarState( 2 );
        }
        else
        {
            UpdateProgressBarState( 1 );
        }

        if ( productsEl && !didRestore )
        {
            WE_QuizResults_ScheduleResultsWidget( productsEl, delayMs );

            // mw 20260314 : removed all this async timer stuff because it's almost certain to go wrong and/or cause performance issues
            //setTimeout( WE_QuizResults_RunEnhanceOnWidgetLoad, delayMs + 1500 );
        }

        WE_QuizResults_RecalculateFooterUI( );
    }
    else if ( slideData.slideType == "ResultsExplore" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-explore" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container ) { container.classList.add( "hidden" ); } );
        
        UpdateProgressBarState( 2 );
        
        const exploreTitle = quiz.querySelector( ".we-onboarding-quiz-results-explore-title" );
        const exploreSubtitle = quiz.querySelector( ".we-onboarding-quiz-results-explore-subtitle" );
        
        if ( exploreTitle && ( !exploreTitle.textContent || exploreTitle.textContent.trim() == "" ) )
        {
            exploreTitle.textContent = "Round out your first order";
        }
        
        if ( exploreSubtitle && ( !exploreSubtitle.textContent || exploreSubtitle.textContent.trim() == "" ) )
        {
            exploreSubtitle.textContent = "Here are more personalised picks based on your quiz answers. Add them to your cart and hit checkout when ready.";
        }
        
        InitializeCategoryCarousels( );
        
        const viewCartBtn = quiz.querySelector( ".we-onboarding-quiz-results-explore-view-cart-btn" );
        if ( viewCartBtn )
        {
            viewCartBtn.onclick = function( e )
            {
                e.preventDefault( );
                const cartRedirectSlide = {
                    slideType: "CartRedirect",
                    position: 9999
                };
                window._onboardingQuizData.slides.push( cartRedirectSlide );
                const slideIndex = window._onboardingQuizData.slides.length - 1;
                ShowSlide( slideIndex, false );
            };
        }
    }
    else if ( slideData.slideType == "CartRedirect" )
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-explore" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-cart-redirect" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.add( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container ) { container.classList.add( "hidden" ); } );
        
        function RedirectToCart( )
        {
            window.location.href = "/cart";
        }

        const cartContent = quiz.querySelector( ".we-onboarding-quiz-cart-redirect-content" );
        if ( cartContent )
        {
            cartContent.style.animation = "none";
            void cartContent.offsetWidth;
            cartContent.style.animation = "cart-content-bob 1.5s ease-in-out infinite, cart-content-zoom-out 0.5s ease-in 1.5s forwards";

            function WE_OnboardingQuizCartRedirect_HandleAnimationEnd( e )
            {
                if ( e.animationName == "cart-content-zoom-out" )
                {
                    cartContent.removeEventListener( "animationend", WE_OnboardingQuizCartRedirect_HandleAnimationEnd );
                    RedirectToCart( );
                }
            }

            cartContent.addEventListener( "animationend", WE_OnboardingQuizCartRedirect_HandleAnimationEnd );
        }
        else
        {
            RedirectToCart( );
        }
    }
    else
    {
        quiz.querySelector( ".we-onboarding-quiz-slide" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-interstitial" ).classList.remove( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-creating" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-custom-picked" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results-loading" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-results" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-welcome" ).classList.add( "hidden" );
        quiz.querySelector( ".we-onboarding-quiz-backdrop" ).classList.remove( "hidden" );
        var buttonContainers = quiz.querySelectorAll( ".we-onboarding-quiz-buttons, .we-onboarding-quiz-buttons-mobile" );
        buttonContainers.forEach( function addHiddenToContainer( container ) { container.classList.add( "hidden" ); } );

        AnimateInterstitialProgressBar( slideData.autoadvanceTime );
    }

    if ( slideData.slideType == "Question" && slideData.answers && slideData.answers.length > 0 )
    {
        answers.classList.remove( "we-onboarding-quiz-answers--image" );
        answers.classList.remove( "we-onboarding-quiz-answers--card" );
        
        const hardcodedDescriptions = {
            "Save money on groceries": "WellEasy brings you competitive prices on premium brands, plus exclusive bundles and autoship discounts.",
            "Quality I can trust": "Every brand is carefully vetted for clean ingredients and sustainable practices you can feel good about.",
            "Shop a specific diet or lifestyle": "Tell us your dietary needs and we'll curate products perfectly matched to your lifestyle.",
            "Healthy groceries without the shopping trip": "Skip the store entirely - we deliver premium health foods straight to your door on your schedule.",
            "Discover healthier swaps": "Our smart recommendations help you find better alternatives for the products you already love."
        };
        
        const isWhatBringsYouSlide = slideData.text && slideData.text.toLowerCase().includes( "what brings you to welleasy" );
        
        var hasCardStyle = false;
        if ( isWhatBringsYouSlide )
        {
            hasCardStyle = true;
        }
        else
        {
            function HasAnswerDescription( ans )
            {
                return ( ans.description && ans.description != "" && ans.description.trim() != "" ) ||
                       ( hardcodedDescriptions[ ans.text ] );
            }
            hasCardStyle = slideData.answers.some( HasAnswerDescription );
        }
        
        if ( hasCardStyle )
        {
            answers.classList.add( "we-onboarding-quiz-answers--card" );
        }

        // remove the strengths from the copy of answer values for the show answer as selected logic
        // (stored format can be "value" or "value:strength" - strip only when colon present)
        var selectedAnswers = data[ slideData.key ];
        if ( selectedAnswers )
        {
            function StripStrengthFromSelected( selectedAnswer, index )
            {
                var value = selectedAnswer;
                var colonIdx = value.indexOf( ":" );
                if ( colonIdx >= 0 )
                {
                    value = value.slice( 0, colonIdx );
                }
                data[ slideData.key ][ index ] = value;
            }
            selectedAnswers.forEach( StripStrengthFromSelected );
        }
        
        function CreateAnswerElement( answerData, index )
        {
            const answer = document.createElement( "div" );
            answer.setAttribute( "class", "we-onboarding-quiz-answer" );
            answer._answerData = answerData;
            
            if ( hasCardStyle )
            {
                answer.classList.add( "we-onboarding-quiz-answer--card" );
                
                const cardContent = document.createElement( "div" );
                cardContent.setAttribute( "class", "we-onboarding-quiz-answer-card-content" );
                
                const iconMap = {
                    "Save money on groceries": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-pound-sterling"><path d="M18 7c0-5.333-8-5.333-8 0"></path><path d="M10 7v14"></path><path d="M6 21h12"></path><path d="M6 13h10"></path></svg>',
                    "Quality I can trust": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-check"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path><path d="m9 12 2 2 4-4"></path></svg>',
                    "Shop a specific diet or lifestyle": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-leaf"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path></svg>',
                    "Healthy groceries without the shopping trip": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-truck"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path><path d="M15 18H9"></path><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path><circle cx="17" cy="18" r="2"></circle><circle cx="7" cy="18" r="2"></circle></svg>',
                    "Discover healthier swaps": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-refresh-cw"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path><path d="M21 3v5h-5"></path><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path><path d="M8 16H3v5"></path></svg>'
                };
                
                const iconSvg = iconMap[ answerData.text ];
                
                const iconContainer = document.createElement( "div" );
                iconContainer.setAttribute( "class", "we-onboarding-quiz-answer-icon-container" );
                
                if ( iconSvg )
                {
                    iconContainer.innerHTML = iconSvg;
                    
                    const svgElements = iconContainer.querySelectorAll( "svg, svg *" );
                    function StyleSVGElement( el )
                    {
                        el.style.stroke = "rgb(14, 196, 185)";
                        el.style.color = "rgb(14, 196, 185)";
                        if ( el.hasAttribute( "stroke" ) && el.getAttribute( "stroke" ) != "none" && el.getAttribute( "stroke" ) != "currentColor" )
                        {
                            el.setAttribute( "stroke", "rgb(14, 196, 185)" );
                        }
                        if ( el.hasAttribute( "fill" ) && el.getAttribute( "fill" ) != "none" )
                        {
                            el.setAttribute( "fill", "none" );
                        }
                    }
                    svgElements.forEach( StyleSVGElement );
                }
                else
                {
                    iconContainer.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle></svg>';
                }
                
                const headerContainer = document.createElement( "div" );
                headerContainer.setAttribute( "class", "we-onboarding-quiz-answer-card-header" );
                headerContainer.appendChild( iconContainer );
                
                const title = document.createElement( "h3" );
                title.setAttribute( "class", "we-onboarding-quiz-answer-title" );
                title.textContent = answerData.text;
                headerContainer.appendChild( title );
                
                cardContent.appendChild( headerContainer );
                
                var descriptionText = hardcodedDescriptions[ answerData.text ];
                if ( !descriptionText && answerData.description && answerData.description != "" && answerData.description.trim() != "" )
                {
                    descriptionText = answerData.description;
                }
                
                const description = document.createElement( "p" );
                description.setAttribute( "class", "we-onboarding-quiz-answer-description" );
                // description.style.display = "block";
                // description.style.maxHeight = "0";
                // description.style.padding = "0 16px";
                // description.style.transform = "translateX(-15px)";
                // description.style.opacity = "0";
                // description.style.transition = "transform 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), opacity 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), max-height 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), padding 400ms cubic-bezier( 0.4, 0, 0.2, 1 )";
                if ( descriptionText )
                {
                    description.textContent = descriptionText;
                }
                cardContent.appendChild( description );
                
                answer.appendChild( cardContent );
            }
            else if ( answerData.sideImage && answerData.sideImage != "" )
            {
                const image = document.createElement( "img" );
                const imageSrc = answerData.sideImage + "&width=100 100w," + answerData.sideImage + "&width=200 200w";
                const sizes = "(max-width: 400px) 100px, 200px";
                image.setAttribute( "class", "we-onboarding-quiz-answer-image");
                image.setAttribute( "src", answerData.sideImage + "&width=400" );
                image.setAttribute( "srcset", imageSrc );
                image.setAttribute( "sizes", sizes );
                image.setAttribute( "alt", answerData.text );
                image.setAttribute( "width", "400" );
                image.setAttribute( "height", "400" );
                if ( index <= 9 )
                {
                    image.setAttribute( "loading", "eager" );
                    image.setAttribute( "fetchpriority", "high" );
                    image.setAttribute( "decoding", "async" );
                }
                answer.appendChild( image );
                
                const textElement = document.createElement( "p" );
                textElement.textContent = answerData.text;
                answer.appendChild( textElement );
                
                var descriptionText = hardcodedDescriptions[ answerData.text ];
                if ( !descriptionText && answerData.description && answerData.description != "" && answerData.description.trim() != "" )
                {
                    descriptionText = answerData.description;
                }
                
                if ( descriptionText )
                {
                    const description = document.createElement( "p" );
                    description.setAttribute( "class", "we-onboarding-quiz-answer-description" );
                    // description.style.display = "block";
                    // description.style.maxHeight = "0";
                    // description.style.padding = "0 16px";
                    // description.style.transform = "translateX(-15px)";
                    // description.style.opacity = "0";
                    // description.style.transition = "transform 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), opacity 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), max-height 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), padding 400ms cubic-bezier( 0.4, 0, 0.2, 1 )";
                    // description.textContent = descriptionText;
                    answer.appendChild( description );
                }
                
                answer.classList.add( "we-onboarding-quiz-answer--image" );
                answer.classList.add( "we-onboarding-quiz-answer--side-image" );
                answers.classList.add( "we-onboarding-quiz-answers--image" );
            }
            else if ( answerData.image && answerData.image != "" )
            {
                const image = document.createElement( "img" );
                const imageSrc = answerData.image + "&width=100 100w," + answerData.image + "&width=200 200w";
                const sizes = "(max-width: 400px) 100px, 200px";
                image.setAttribute( "class", "we-onboarding-quiz-answer-image");
                image.setAttribute( "src", answerData.image + "&width=400" );
                image.setAttribute( "srcset", imageSrc );
                image.setAttribute( "sizes", sizes );
                image.setAttribute( "alt", answerData.text );
                image.setAttribute( "width", "400" );
                image.setAttribute( "height", "400" );
                if ( index <= 9 )
                {
                    image.setAttribute( "loading", "eager" );
                    image.setAttribute( "fetchpriority", "high" );
                    image.setAttribute( "decoding", "async" );
                }
                answer.appendChild( image );
                
                var descriptionText = hardcodedDescriptions[ answerData.text ];
                if ( !descriptionText && answerData.description && answerData.description != "" && answerData.description.trim() != "" )
                {
                    descriptionText = answerData.description;
                }
                
                if ( descriptionText )
                {
                    const description = document.createElement( "p" );
                    description.setAttribute( "class", "we-onboarding-quiz-answer-description" );
                    // description.style.display = "block";
                    // description.style.maxHeight = "0";
                    // description.style.padding = "0 16px";
                    // description.style.transform = "translateX(-15px)";
                    // description.style.opacity = "0";
                    // description.style.transition = "transform 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), opacity 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), max-height 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), padding 400ms cubic-bezier( 0.4, 0, 0.2, 1 )";
                    description.textContent = descriptionText;
                    answer.appendChild( description );
                }
                
                answer.classList.add( "we-onboarding-quiz-answer--image" );
                answers.classList.add( "we-onboarding-quiz-answers--image" );
            }
            else
            {
                answer.innerHTML = "<p>" + answerData.text + "</p>";
                
                var descriptionText = hardcodedDescriptions[ answerData.text ];
                if ( !descriptionText && answerData.description && answerData.description != "" && answerData.description.trim() != "" )
                {
                    descriptionText = answerData.description;
                }
                
                if ( descriptionText )
                {
                    const description = document.createElement( "p" );
                    description.setAttribute( "class", "we-onboarding-quiz-answer-description" );
                    // description.style.display = "block";
                    // description.style.maxHeight = "0";
                    // description.style.padding = "0 16px";
                    // description.style.transform = "translateX(-15px)";
                    // description.style.opacity = "0";
                    // description.style.transition = "transform 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), opacity 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), max-height 400ms cubic-bezier( 0.4, 0, 0.2, 1 ), padding 400ms cubic-bezier( 0.4, 0, 0.2, 1 )";
                    description.textContent = descriptionText;
                    answer.appendChild( description );
                }
            }

            if ( ( data[ slideData.key ] ) && ( data[ slideData.key ].includes( answerData.value ) ) )
            {
                answer.classList.add( "we-onboarding-quiz-selected-answer" );
                
                // const description = answer.querySelector( ".we-onboarding-quiz-answer-description" );
                // if ( description )
                // {
                //     description.style.maxHeight = "500px";
                //     description.style.padding = "12px 16px";
                //     description.style.transform = "translateX(0)";
                //     description.style.opacity = "1";
                // }
            }

            answer.addEventListener( "click", AnswerClicked );

            answers.appendChild( answer );
        }
        slideData.answers.forEach( CreateAnswerElement );
    }

    if ( !firstLoad && slideData.slideType == "Question" )
    {
        var qp = ParseQP( );
        qp.slide = slideData.position;
        window.history.pushState( "", "", window.location.pathname + MakeQPStr( qp ) );
    }
    SaveOnboardingQuizState( );

    if ( slideData.autoadvanceTime )
    {
        var nextIdx = idx + 1;

        function WE_OnboardingQuizSlideAdvanceAnimationEnd( e )
        {
            var el = e.currentTarget;
            var activeEl = ( quizEl ? quizEl._weOnboardingQuizSlideAdvanceEl : null );

            if ( el && activeEl && el == activeEl )
            {
                if ( quizEl )
                {
                    quizEl._weOnboardingQuizSlideAdvanceEl = null;
                }
                if ( el.parentNode )
                {
                    el.parentNode.removeChild( el );
                }
                ShowSlide( nextIdx );
            }
        }

        if ( quiz )
        {
            var quizEl = quiz;

            if ( quizEl._weOnboardingQuizSlideAdvanceEl )
            {
                if ( quizEl._weOnboardingQuizSlideAdvanceEl.parentNode )
                {
                    quizEl._weOnboardingQuizSlideAdvanceEl.parentNode.removeChild( quizEl._weOnboardingQuizSlideAdvanceEl );
                }
                quizEl._weOnboardingQuizSlideAdvanceEl = null;
            }

            var timerEl = document.createElement( "div" );
            timerEl.setAttribute( "class", "we-onboarding-quiz-slide-advance-timer" );
            timerEl.style.animation = "we-onboarding-quiz-slide-advance 1ms linear both";
            timerEl.style.animationDelay = slideData.autoadvanceTime + "ms";
            timerEl.addEventListener( "animationend", WE_OnboardingQuizSlideAdvanceAnimationEnd );
            quizEl.appendChild( timerEl );
            quizEl._weOnboardingQuizSlideAdvanceEl = timerEl;
        }
        else
        {
            ShowSlide( nextIdx );
        }
    }
    }
}

function InitializeCategoryCarousels( )
{
    const categories = document.querySelectorAll( ".we-onboarding-quiz-results-explore-category" );
    
    function InitializeCategory( category )
    {
        const productsContainer = category.querySelector( ".we-onboarding-quiz-results-explore-category-products" );
        const prevBtn = category.querySelector( ".we-onboarding-quiz-results-explore-category-nav-btn--prev" );
        const nextBtn = category.querySelector( ".we-onboarding-quiz-results-explore-category-nav-btn--next" );
        
        if ( productsContainer && prevBtn && nextBtn )
        {
        function UpdateNavButtons( )
        {
            const scrollLeft = productsContainer.scrollLeft;
            const scrollWidth = productsContainer.scrollWidth;
            const clientWidth = productsContainer.clientWidth;
            
            if ( scrollLeft <= 0 )
            {
                prevBtn.classList.add( "hidden" );
            }
            else
            {
                prevBtn.classList.remove( "hidden" );
            }
            
            if ( scrollLeft + clientWidth >= scrollWidth - 10 )
            {
                nextBtn.classList.add( "hidden" );
            }
            else
            {
                nextBtn.classList.remove( "hidden" );
            }
        }
        
        function HandlePrevClick( )
        {
            productsContainer.scrollBy( { left: -300, behavior: "smooth" } );
        }
        
        function HandleNextClick( )
        {
            productsContainer.scrollBy( { left: 300, behavior: "smooth" } );
        }
        
        prevBtn.addEventListener( "click", HandlePrevClick );
        nextBtn.addEventListener( "click", HandleNextClick );
        productsContainer.addEventListener( "scroll", UpdateNavButtons );
        UpdateNavButtons( );
        }
    }
    
    categories.forEach( InitializeCategory );
}

function ShowAnswerOptions( answerData, answerParent )
{
    var overlay          = document.querySelector( ".we-onboarding-quiz-options-overlay" );
    var popup            = document.querySelector( ".we-onboarding-quiz-options" );
    var header           = document.querySelector( ".we-onboarding-quiz-options-question" );
    var answersContainer = document.querySelector( ".we-onboarding-quiz-options-values" );

    overlay.classList.add( "we-onboarding-quiz-options-overlay--visible" );
    popup.classList.add( "we-onboarding-quiz-options--visible" );

    header.innerText = answerData.optionsQuestion;

    while ( answersContainer.firstChild )
    {
        answersContainer.firstChild.remove( );
    }

    function CreateOptionElement( answer )
    {
        const answerEl = document.createElement( "div" );
        answerEl.setAttribute( "class", "we-onboarding-quiz-answer" );
        answerEl._answerData = answer;
        answerEl.innerHTML = "<p>" + answer.text + "</p>";
        answerEl.addEventListener( "click", function onAnswerOptionClick( e )
        {
            OptionClicked( e, answerParent );
        });
        answersContainer.appendChild( answerEl );
    }
    answerData.options.forEach( CreateOptionElement );
}

function OptionClicked( e, answerParent )
{
    // remove the selected answer styling as SaveOnboardingQuizAnswers will save it separately to it's parent if present,
    // there is logic to join the answers in that function
    var options = document.querySelectorAll( ".we-onboarding-quiz-options-values .we-onboarding-quiz-answer" );
    options.forEach( function clearSelectedOptionStyle( option )
    {
        option.classList.remove( "we-onboarding-quiz-selected-answer" );
    } );
    var selectedOption = e.currentTarget._answerData.value;
    answerParent._answerData.selectedOption = selectedOption;
    CloseOptionsPopup( );
    SaveOnboardingQuizAnswers( );
}

function CloseOptionsPopup( )
{
    var overlay = document.querySelector( ".we-onboarding-quiz-options-overlay" );
    var popup   = document.querySelector( ".we-onboarding-quiz-options" );

    if ( overlay )
    {
        overlay.classList.remove( "we-onboarding-quiz-options-overlay--visible" );
    }
    if ( popup )
    {
        popup.classList.remove( "we-onboarding-quiz-options--visible" );
    }
}

function NavigateToRegisterFromQuiz( )
{
    if ( window._onboardingQuizData && window._onboardingQuizData.auth )
    {
        window.location.href = "/pages/welleasy-quiz?slide=16";
    }
    else
    {
        try { sessionStorage.setItem( "we_register_flow", "quiz" ); } catch ( e ) {}
        window.location.href = "/account/register";
    }
}

function NextOnboardingSlide( e )
{
    var quiz                   = null;
    var currentIdx             = 0;
    var slideData              = null;
    var idx                    = 0;
    var errorPrompt            = null;
    var shouldScheduleRegister = false;

    quiz = document.querySelector( ".we-onboarding-quiz" );

    if ( quiz )
    {
        currentIdx = Number( quiz.getAttribute( "data-idx" ) );
        slideData  = window._onboardingQuizData.slides[ currentIdx ];

        if ( slideData && Number( slideData.position ) == 15 )
        {
            shouldScheduleRegister = true;
        }
        else
        {
            idx = currentIdx + 1;
            if ( idx < window._onboardingQuizData.slides.length )
            {
                errorPrompt = document.querySelector( ".we-onboarding-quiz .we-onboarding-quiz-error-prompt" );
                if ( errorPrompt )
                {
                    errorPrompt.classList.add( "hidden" );
                }
                ShowSlide( idx );
            }
        }
    }
    if ( shouldScheduleRegister )
    {
        NavigateToRegisterFromQuiz( );
    }
}

function PreviousOnboardingSlide( e )
{
    var idx = Number( document.querySelector( ".we-onboarding-quiz" ).getAttribute( "data-idx" ) );
    if ( idx > 0 )
    {
        var previousIdx = idx - 1;
        var validSlideFound = false;
        while ( previousIdx >= 0 && validSlideFound == false )
        {
            var slide = window._onboardingQuizData.slides[ previousIdx ];
            if ( slide && slide.slideType == "Question" )
            {
                validSlideFound = true;
                ShowSlide( previousIdx );
            }
            previousIdx --;
        }
    }

    document.querySelector( ".we-onboarding-quiz .we-onboarding-quiz-error-prompt" ).classList.add( "hidden" );
}


function StartOnboardingQuiz( )
{
    var prevBtns       = null;
    var nextBtns       = null;
    var optionsOverlay = null;
    var optionsClose   = null;
    var qp             = null;
    var slideIdx       = 0;
    var targetPosition = 0;
    var i              = 0;
    var slidePosition  = 0;

    if ( window._onboardingQuizData && window._onboardingQuizData.slides )
    {
    function SortSlidesByPosition( a, b )
    {
        return ( a.position - b.position );
    }
    window._onboardingQuizData.slides.sort( SortSlidesByPosition );

    prevBtns = document.querySelectorAll( ".we-onboarding-quiz-prev" );
    nextBtns = document.querySelectorAll( ".we-onboarding-quiz-next" );
    
    prevBtns.forEach( function bindPrevBtnClick( prevBtn )
    {
        prevBtn.addEventListener( "click", PreviousOnboardingSlide );
    });
    
    nextBtns.forEach( function bindNextBtnClick( nextBtn )
    {
        nextBtn.addEventListener( "click", NextOnboardingSlide );
    });

    optionsOverlay = document.querySelector( ".we-onboarding-quiz-options-overlay" );
    optionsClose = document.querySelector( ".we-onboarding-quiz-options-close" );
    
    if ( optionsOverlay )
    {
        optionsOverlay.addEventListener( "click", CloseOptionsPopup );
    }
    
    if ( optionsClose )
    {
        optionsClose.addEventListener( "click", CloseOptionsPopup );
    }

    qp = ParseQP( );

    if ( qp.slide != undefined && qp.slide != "" )
    {
        targetPosition = parseInt( qp.slide, 10 );
        if ( !isNaN( targetPosition ) )
        {
            for ( i = 0; i < window._onboardingQuizData.slides.length; i++ )
            {
                slidePosition = parseInt( window._onboardingQuizData.slides[ i ].position, 10 );
                if ( !isNaN( slidePosition ) && slidePosition == targetPosition )
                {
                    slideIdx = i;
                    break;
                }
            }
        }
    }

    ShowSlide( slideIdx, true );
    }
    else
    {
        console.error( "Quiz data not found" );
    }
} 

StartOnboardingQuiz( );

function WE_OnboardingQuizResults_SetQuizCardRemovedState( card, isRemoved )
{
    var addBack = null;

    addBack = card.querySelector( ".we-quiz-card__add-back" );

    if ( isRemoved )
    {
        card.classList.add( "we-quiz-card--removed" );
    }
    else
    {
        card.classList.remove( "we-quiz-card--removed" );
    }

    if ( addBack )
    {
        addBack.hidden = !isRemoved;
    }
}

function WE_OnboardingQuizResults_GetDrawer( )
{
    var drawer = null;

    drawer = document.querySelector( ".we-quiz-drawer" );

    return drawer;
}

function WE_QuizResults_DrawerProductFetchResolve( product, drawerIngredients, drawerNutrition )
{
    var desc = ( product && product.description ) ? product.description : "";

    if ( drawerIngredients ) { drawerIngredients.innerHTML = desc; }
    if ( drawerNutrition )   { drawerNutrition.innerHTML = desc; }
}

function WE_QuizResults_DrawerProductFetchReject( )
{
}

function WE_QuizResults_DrawerProductFetchParse( r )
{
    return r.json( );
}

function WE_OnboardingQuizResults_PopulateDrawerFromCard( drawer, card )
{
    var imgEl             = null;
    var vendorEl          = null;
    var titleEl           = null;
    var drawerImg         = null;
    var drawerVendor      = null;
    var drawerTitle       = null;
    var drawerIngredients = null;
    var drawerNutrition   = null;
    var whyShownEl        = null;
    var whyShownReasons   = null;
    var whyShownProduct   = null;
    var ecPopup           = null;
    var reasonsData       = null;
    var reasons           = [];
    var i                 = 0;
    var imgSrc            = "";
    var vendor            = "";
    var title             = "";
    var productUrl        = "";
    var handleMatch       = null;
    var handle            = "";

    imgEl = card.querySelector( ".we-quiz-card__image-img" ) || card.querySelector( ".ec-product-image-container img, .product-card__image img, [id=\"product-card-image-container\"] img" );
    if ( imgEl )
    {
        imgSrc = imgEl.getAttribute( "src" ) || "";
    }

    vendorEl = card.querySelector( ".we-quiz-card__vendor" ) || card.querySelector( ".ec-product-vendor, .product-card__brand" );
    if ( vendorEl )
    {
        vendor = ( vendorEl.textContent || "" ).trim( );
    }

    titleEl = card.querySelector( ".we-quiz-card__title" ) || card.querySelector( ".ec-product-title, .product-card__title" );
    if ( titleEl )
    {
        title = ( titleEl.textContent || "" ).trim( );
    }

    drawerImg = drawer.querySelector( ".we-quiz-drawer__img" );
    if ( drawerImg )
    {
        drawerImg.setAttribute( "src", imgSrc );
        drawerImg.setAttribute( "alt", title );
    }

    drawerVendor = drawer.querySelector( ".we-quiz-drawer__vendor" );
    if ( drawerVendor )
    {
        drawerVendor.textContent = vendor;
    }

    drawerTitle = drawer.querySelector( ".we-quiz-drawer__title" );
    if ( drawerTitle )
    {
        drawerTitle.textContent = title;
    }

    drawerIngredients = drawer.querySelector( ".we-quiz-drawer__ingredients" );
    drawerNutrition   = drawer.querySelector( ".we-quiz-drawer__nutrition" );
    if ( drawerIngredients ) { drawerIngredients.innerHTML = ""; }
    if ( drawerNutrition )   { drawerNutrition.innerHTML = ""; }

    whyShownEl = drawer.querySelector( ".we-quiz-drawer__why-shown" );
    whyShownReasons = drawer.querySelector( ".we-quiz-drawer__why-shown-reasons" );
    whyShownProduct = drawer.querySelector( ".we-quiz-drawer__why-shown-product" );
    reasons = [];
    if ( whyShownEl && whyShownReasons )
    {
        reasonsData = card.getAttribute( "data-ec-reasons" ) || card.getAttribute( "data-ec-dev-reasons" );
        if ( reasonsData )
        {
            try { reasons = JSON.parse( reasonsData ); } catch ( err ) { reasons = []; }
            if ( !Array.isArray( reasons ) ) { reasons = []; }
        }
        if ( reasons.length == 0 )
        {
            ecPopup = card.querySelector( ".ec-dev-popup" );
            if ( !ecPopup )
            {
                ecPopup = document.querySelector( ".ec-dev-popup" );
                if ( ecPopup && title )
                {
                    var popupH4 = ecPopup.querySelector( "h4" );
                    if ( !popupH4 || ( popupH4.textContent || "" ).trim() != title )
                    { ecPopup = null; }
                }
            }
            if ( ecPopup )
            {
                var popupParas = ecPopup.querySelectorAll( "p" );
                for ( i = 0; i < popupParas.length; i++ )
                {
                    reasons.push( ( popupParas[ i ].textContent || "" ).trim() );
                }
                reasons = reasons.filter( function( r ) { return r.length > 0; } );
            }
        }
        if ( reasons.length > 0 )
        {
            if ( whyShownProduct ) { whyShownProduct.textContent = title || ""; }
            whyShownReasons.innerHTML = "";
            for ( i = 0; i < reasons.length; i++ )
            {
                var p = document.createElement( "p" );
                p.textContent = reasons[ i ];
                whyShownReasons.appendChild( p );
            }
            whyShownEl.removeAttribute( "hidden" );
        }
        else
        {
            whyShownEl.setAttribute( "hidden", "hidden" );
        }
    }

    productUrl = "";
    try
    {
        var dataStr = card.getAttribute( "data-product-data" ) || "";
        var dataObj = dataStr ? JSON.parse( dataStr ) : null;
        if ( dataObj && dataObj.url ) { productUrl = dataObj.url; }
    }
    catch ( err ) { }
    if ( !productUrl )
    {
        var linkEl = card.querySelector( "a[href*=\"/products/\"]" );
        if ( linkEl ) { productUrl = linkEl.getAttribute( "href" ) || ""; }
    }

    handleMatch = productUrl ? productUrl.match( /\/products\/([^/?]+)/ ) : null;
    handle      = handleMatch ? handleMatch[ 1 ] : "";

    if ( handle )
    {
        function HandleDrawerProductFetched( product )
        {
            WE_QuizResults_DrawerProductFetchResolve( product, drawerIngredients, drawerNutrition );
        }
        fetch( "/products/" + handle + ".js" )
            .then( WE_QuizResults_DrawerProductFetchParse )
            .then( HandleDrawerProductFetched )
            .catch( WE_QuizResults_DrawerProductFetchReject );
    }
}

function WE_OnboardingQuizResults_OpenDrawer( button, card )
{
    var drawer = null;

    if ( card && typeof window.dispatchEvent == "function" )
    {
        try
        {
            window.dispatchEvent( new CustomEvent( "we-quiz-drawer-will-open", { detail: { card: card }, bubbles: true } ) );
        }
        catch ( err ) { }
    }

    drawer = WE_OnboardingQuizResults_GetDrawer( );

    if ( drawer )
    {
        WE_OnboardingQuizResults_PopulateDrawerFromCard( drawer, card );
        drawer.classList.add( "we-quiz-drawer--open" );
        drawer.setAttribute( "aria-hidden", "false" );
        document.body.classList.add( "we-quiz-drawer-open" );
    }

    if ( button )
    {
        button.setAttribute( "aria-expanded", "true" );
    }
}

function WE_OnboardingQuizResults_CloseDrawer( )
{
    var drawer          = null;
    var expandedButtons = null;
    var i               = 0;

    drawer = WE_OnboardingQuizResults_GetDrawer( );

    if ( drawer )
    {
        drawer.classList.remove( "we-quiz-drawer--open" );
        drawer.setAttribute( "aria-hidden", "true" );
    }

    document.body.classList.remove( "we-quiz-drawer-open" );

    expandedButtons = document.querySelectorAll( ".we-quiz-card__reason[aria-expanded='true']" );

    for ( i = 0; i < expandedButtons.length; i++ )
    {
        expandedButtons[ i ].setAttribute( "aria-expanded", "false" );
    }
}

function WE_ParseMoneyValue( value )
{
    var result = 0;

    if ( value )
    {
        result = parseFloat( value.replace( /[^0-9.]/g, "" ) ) || 0;
    }

    return result;
}

function WE_QuizResults_RevealProductsContainer( )
{
    var productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );
    if ( productsEl )
    {
        productsEl.classList.add( "we-onboarding-quiz-results-products--visible" );
    }
}

// mw 20260322 : removing async stuff implemented using requestAnimationFrame
//function WE_QuizResults_RevealProductsContainerTick( )
//{
//    var productsEl     = document.querySelector( ".we-onboarding-quiz-results-products" );
//    var shouldReveal   = false;
//    var revealAt       = 0;
//
//    if ( productsEl )
//    {
//        revealAt = productsEl._weQuizResultsRevealAt || 0;
//
//        if ( revealAt && Date.now( ) >= revealAt )
//        {
//            shouldReveal = true;
//        }
//    }
//
//    if ( shouldReveal )
//    {
//        productsEl.classList.add( "we-onboarding-quiz-results-products--visible" );
//    }
//    else
//    {
//        requestAnimationFrame( WE_QuizResults_RevealProductsContainerTick );
//    }
//}

function WE_QuizResults_GetResultsCacheSignature( )
{
    var quizStateStr = "";
    var authSig      = "";
    var auth          = null;
    var authId       = "";
    var authEmail    = "";
    var result       = "";

    quizStateStr = localStorage.getItem( LOCALSTORAGE_KEY_NAME ) || "";
    auth = window._onboardingQuizData.auth;

    if ( auth )
    {
        if ( auth.id != undefined && auth.id != null )
        {
            authId = String( auth.id );
        }

        if ( auth.email != undefined && auth.email != null )
        {
            authEmail = String( auth.email );
        }
    }

    if ( authId != "" || authEmail != "" )
    {
        authSig = authId + ":" + authEmail;
    }

    result = authSig + "|" + quizStateStr;
    return result;
}

function WE_QuizResults_HasImagesSrcResolved( productsEl )
{
    var cards      = null;
    var imgEl      = null;
    var url        = "";
    var src        = "";
    var resolved   = false;
    var mainImgSel = ".we-quiz-card__image-img, .ec-product-image-container img, .product-card__image img, .product-card__image__img, [id=\"product-card-image-container\"] img";
    var i          = 0;
    var totalCards = 0;
    var okCount    = 0;
    var allOk      = true;

    if ( productsEl )
    {
        cards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );
        totalCards = cards.length;

        for ( i = 0; i < totalCards; i++ )
        {
            if ( !allOk )
            {
                break;
            }

            imgEl = cards[ i ].querySelector( mainImgSel );
            if ( imgEl )
            {
                url = WE_QuizResults_GetMainImageUrl( imgEl );
                if ( url )
                {
                    src = imgEl.getAttribute( "src" ) || "";
                    if ( src == url )
                    {
                        okCount ++;
                    }
                    else
                    {
                        allOk = false;
                    }
                }
                else
                {
                    allOk = false;
                }
            }
            else
            {
                allOk = false;
            }
        }
    }

    if ( totalCards > 0 && allOk && okCount == totalCards )
    {
        resolved = true;
    }

    return resolved;
}


function WE_QuizResults_GetProductsDomCacheKeyName( )
{
    return LOCALSTORAGE_KEY_NAME + "_results_products_dom_cache_v3";
}

// mw 20260322 : removing the DOM cache, it was supposed to be a network cache
//function WE_QuizResults_SaveProductsDomCache( productsEl )
//{
//    if ( productsEl && !productsEl._weQuizResultsProductsDomCacheSaved && !productsEl._weQuizResultsProductsDomCacheSaving )
//    {
//        productsEl._weQuizResultsProductsDomCacheSaving = true;
//
//        WE_QuizResults_PollSaveProductsDomCache( productsEl, 0 );
//    }
//}
//
//function WE_QuizResults_PollSaveProductsDomCache( productsEl, frameCount )
//{
//    const maxFrames = 240;
//    var canPoll = false;
//
//    if ( productsEl && !productsEl._weQuizResultsProductsDomCacheSaved )
//    {
//      canPoll = true;
//    }
//
//    if ( canPoll )
//    {
//        var cacheKey = WE_QuizResults_GetProductsDomCacheKeyName( );
//        var signature = WE_QuizResults_GetResultsCacheSignature( );
//
//        WE_QuizResults_ForceLoadWidgetImages( productsEl );
//        WE_QuizResults_PopulatePlaceholderImages( );
//
//        if ( WE_QuizResults_HasImagesSrcResolved( productsEl ) )
//        {
//            var cacheData = null;
//
//            cacheData = {
//                "signature" : signature,
//                "productsHtml" : productsEl.innerHTML
//            };
//
//            localStorage.setItem( cacheKey, JSON.stringify( cacheData ) );
//            productsEl._weQuizResultsProductsDomCacheSaved = true;
//            productsEl._weQuizResultsProductsDomCacheSaving = false;
//            console.log( "[WE Quiz Cache] save success", cacheKey, signature );
//        }
//        else if ( frameCount < maxFrames )
//        {
//            requestAnimationFrame( function WE_QuizResults_PollSaveProductsDomCacheTick( )
//            {
//                WE_QuizResults_PollSaveProductsDomCache( productsEl, frameCount + 1 );
//            } );
//        }
//        else
//        {
//            productsEl._weQuizResultsProductsDomCacheSaving = false;
//            console.log( "[WE Quiz Cache] save fail", cacheKey, signature );
//        }
//    }
//}

function WE_QuizResults_RestoreProductsDomCache( productsEl )
{
    var restored = false;
    var cacheKey = "";
    var cachedStr = "";
    var cached = null;
    var signature = "";

    if ( productsEl )
    {
        cacheKey = WE_QuizResults_GetProductsDomCacheKeyName( );
        signature = WE_QuizResults_GetResultsCacheSignature( );
        cachedStr = localStorage.getItem( cacheKey );

        if ( cachedStr )
        {
            try
            {
                cached = JSON.parse( cachedStr );
            }
            catch ( e )
            {
                cached = null;
            }

            if ( cached && cached.signature == signature && cached.productsHtml )
            {
                productsEl.innerHTML = cached.productsHtml;
                productsEl._weQuizResultsProductsDomCacheRestored = true;
                restored = true;
            }
        }
    }

    if ( restored )
    {
        console.log( "[WE Quiz Cache] restore hit", cacheKey, signature );
    }
    else
    {
        var cachedStrLen = 0;
        if ( cachedStr )
        {
            cachedStrLen = cachedStr.length;
        }
        console.log( "[WE Quiz Cache] restore miss", cacheKey, signature, "cachedStrLen", cachedStrLen );
    }

    return restored;
}

function WE_QuizResults_RunEnhanceOnWidgetLoad( )
{
    WE_QuizResults_EnhanceECCards( );
    WE_QuizResults_RecalculateFooterUI( );
}


function WE_QuizResults_LoadWidget( productsEl )
{
    //var widget      = null;
    //const hasWidget = productsEl.querySelector( ".enhanced-commerce-widget" );
    //
    //if ( hasWidget )
    //{
    //    //productsEl._weQuizResultsWidgetLoaded = true;
    //    WE_QuizResults_ApplyCachedVariantIds( productsEl );
    //    WE_QuizResults_ApplyCachedProductImages( productsEl );
    //    WE_QuizResults_ForceLoadWidgetImages( productsEl );
    //    WE_QuizResults_RunEnhanceOnWidgetLoad( );
    //    WE_QuizResults_PopulatePlaceholderImages( );
    //}
    //else
    {
        productsEl._weQuizResultsEnhanceComplete = false;
        SaveOnboardingQuizState( );

        // mw 20260322 : this is how app-specific clientside network caching should work
        function OnWidgetLoadResponse( widgetLoadResponse )
        {
            productsEl._cachedNetworkResponse = widgetLoadResponse;
            WE_QuizResults_WaitForCardsThenEnhance( productsEl, 0 );
        }
        
        var makeNetworkRequest = true;
        var oldWidget          = productsEl.querySelector( ".enhanced-commerce-widget" );
        if ( ( productsEl._cachedNetworkResponse ) && ( oldWidget ) )
        {
            console.log( "could use cached data here", productsEl._cachedNetworkResponse );
            //makeNetworkRequest = false;
        }

        if ( makeNetworkRequest )
        {
            //productsEl._weQuizResultsWidgetLoading = true;

            // remove old widget if there is one
            if ( oldWidget )
            {
                oldWidget.remove( );
            }

            // add a new one
            var param =
            {
                "type"               : "custom",
                "name"               : "quiz results",
                "title"              : "EC Quiz Results",
                "brandLimit"         : 3,
                "defaultVendorLimit" : 2,
                "vendorLimits"       : { "WELLEASY" : 3 }
            };

            var widget = EC_CreateWidget( param, OnWidgetLoadResponse );
            
            productsEl.appendChild( widget );
        }
        WE_QuizResults_ApplyCachedProductImages( productsEl );
        //productsEl._weQuizResultsWidgetLoaded = true;
        WE_QuizResults_WaitForCardsThenEnhance( productsEl, 0 );
    }
}

function WE_QuizResults_WaitForCardsThenEnhance( productsEl, frameCount )
{
    const maxFrames  = 300;
    const cards      = productsEl.querySelectorAll( ".product-grid__product-card, .ec-product-card, .product-card" );
    var i             = 0;
    var totalCards   = cards.length;
    var enhancedCards = 0;

    WE_QuizResults_ForceLoadWidgetImages( productsEl );
    WE_QuizResults_PopulatePlaceholderImages( );

    WE_QuizResults_ApplyCachedVariantIds( productsEl );

    enhancedCards = productsEl.querySelectorAll( ".we-quiz-card" ).length;

    if ( enhancedCards > 0 && enhancedCards == totalCards && !productsEl._weQuizResultsEnhanceComplete )
    {
        productsEl._weQuizResultsEnhanceComplete = true;
        WE_QuizResults_RunEnhanceOnWidgetLoad( );
        WE_QuizResults_SaveCachedProductImages( productsEl );
        //WE_QuizResults_ScheduleFollowUpEnhance( productsEl, 20, 0, 0 );
    }
    else if ( totalCards > 0 && !productsEl._weQuizResultsEnhanceComplete )
    {
        // Fallback pass when cards exist but enhancement classes are not all applied yet.
        WE_QuizResults_RunEnhanceOnWidgetLoad( );
    }
}

//function WE_QuizResults_ScheduleFollowUpEnhance( productsEl, framesLeft, previousCount, passCount )
//{
//    const maxPasses = 20;
//
//    if ( framesLeft > 0 )
//    {
//        requestAnimationFrame( function WE_QuizResults_FollowUpEnhanceNextFrame( )
//        {
//            WE_QuizResults_ScheduleFollowUpEnhance( productsEl, framesLeft - 1, previousCount, passCount );
//        } );
//    }
//    else
//    {
//        WE_QuizResults_RunEnhanceOnWidgetLoad( );
//        WE_QuizResults_RecalculateFooterUI( );
//        const count = productsEl.querySelectorAll( ".we-quiz-card" ).length;
//        if ( count > previousCount && passCount < maxPasses )
//        {
//            WE_QuizResults_ScheduleFollowUpEnhance( productsEl, 15, count, passCount + 1 );
//        }
//        else
//        {
//            WE_QuizResults_SaveProductsDomCache( productsEl );
//        }
//    }
//}

function WE_QuizResults_OnProductsMutate( )
{
    WE_QuizResults_RunEnhanceOnWidgetLoad( );
}

function WE_QuizResults_DisconnectObserver( observer )
{
    observer.disconnect( );
}

function WE_QuizResults_EnhancePollTick( )
{
    WE_QuizResults_RunEnhanceOnWidgetLoad( );
}

function WE_QuizResults_EnhancePollSwitchToSlow( fastPollId )
{
    clearInterval( fastPollId );
    WE_QuizResults_EnhancePollTick( );
}

function WE_QuizResults_ClearEnhancePoll( pollId )
{
    clearInterval( pollId );
}

// mw 20260314 : removed all this async timer stuff because it's almost certain to go wrong and/or cause performance issues
//function WE_QuizResults_WaitForApiTick( productsEl, intervalRef, attemptsRef )
//{
//    attemptsRef[ 0 ]++;
//    if ( window.SendAPIRequest )
//    {
//        clearInterval( intervalRef[ 0 ] );
//        SaveOnboardingQuizState( );
//        setTimeout( WE_QuizResults_LoadWidget, 300, productsEl );
//    }
//    else if ( attemptsRef[ 0 ] >= 150 )
//    {
//        clearInterval( intervalRef[ 0 ] );
//        setTimeout( WE_QuizResults_LoadWidget, 300, productsEl );
//    }
//}

//function Really_WE_QuizResults_ScheduleResultsWidget( productsEl )
//{
//    if ( window.EC_CreateWidget )
//    {
//        WE_QuizResults_LoadWidget( productsEl );
//    }
//    else
//    {
//        productsEl._weQuizResultsWidgetRetrying = true;
//        productsEl._weQuizResultsWidgetRetryFrameCount = 0;
//        requestAnimationFrame( WE_QuizResults_AttemptLoadWidgetTick );
//    }
//}
//
//function WE_QuizResults_RetryScheduleResultsWidget( productsEl )
//{
//    Really_WE_QuizResults_ScheduleResultsWidget( productsEl );
//}


// mw 20260322 : ignore delay parameter, it's always zero and isn't used anyway
// to do : remove it !
function WE_QuizResults_ScheduleResultsWidget( productsEl, delayMs )
{
    if ( productsEl )
    {
        // mw 20260322 : remove check for "hasWidget" here because it's made in WE_QuizResults_LoadWidget
        //var hasWidget = productsEl.querySelector( ".enhanced-commerce-widget" );

        //if ( hasWidget )
        //{
        //    WE_QuizResults_RunEnhanceOnWidgetLoad( );
        //    WE_QuizResults_PopulatePlaceholderImages( );
        //}
        //else
        if ( window.EC_CreateWidget )
        {
            WE_QuizResults_LoadWidget( productsEl );
        }
        else
        {
            // mw 20260322 : removing all polling
            //productsEl._weQuizResultsWidgetRetrying = true;
            //productsEl._weQuizResultsWidgetRetryFrameCount = 0;
            //requestAnimationFrame( WE_QuizResults_AttemptLoadWidgetTick );

            function WE_QuizResults_LoadWidgetOnEcReady( )
            {
                WE_QuizResults_LoadWidget( productsEl );
                window.removeEventListener( "enhancedcommerce:ready", WE_QuizResults_LoadWidgetOnEcReady );
            }

            window.addEventListener( "enhancedcommerce:ready", WE_QuizResults_LoadWidgetOnEcReady );

            // Safari can miss enhancedcommerce:ready if it already fired before this listener attached.
            if ( window.EC_CreateWidget )
            {
                WE_QuizResults_LoadWidgetOnEcReady( );
            }
        }
    }
}

function WE_QuizResults_AttemptLoadWidgetTick( )
{
    const maxFrames = 60;
    var productsEl = null;
    var frameCount = 0;
    var hasWidget = false;
    var shouldContinue = false;

    productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );

    if ( productsEl )
    {
        frameCount = productsEl._weQuizResultsWidgetRetryFrameCount || 0;
        hasWidget = productsEl.querySelector( ".enhanced-commerce-widget" );

        if ( productsEl._weQuizResultsProductsDomCacheRestored )
        {
            hasWidget = true;
            shouldContinue = false;
            productsEl._weQuizResultsWidgetRetrying = false;
        }
        if ( hasWidget )
        {
            productsEl._weQuizResultsWidgetRetrying = false;
        }
        else if ( window.EC_CreateWidget )
        {
            productsEl._weQuizResultsWidgetRetrying = false;
            WE_QuizResults_LoadWidget( productsEl );
        }
        else if ( frameCount < maxFrames )
        {
            productsEl._weQuizResultsWidgetRetryFrameCount = frameCount + 1;
            shouldContinue = true;
        }
        else
        {
            productsEl._weQuizResultsWidgetRetrying = false;
        }
    }

    if ( shouldContinue )
    {
        // No scheduled retries: requestAnimationFrame is disabled.
    }
}

// mw 20260314 : removed this because it was calling the back-end 4 times to show one results slide
//function original_WE_QuizResults_ScheduleResultsWidget( productsEl, delayMs )
//{
//    var attempts    = [ 0 ];
//    var intervalRef = [ null ];
//    var doLoadNow   = false;
//
//    if ( !window._onboardingQuizData.auth )
//    {
//        doLoadNow = true;
//    }
//    else if ( window.SendAPIRequest )
//    {
//        SaveOnboardingQuizState( );
//        doLoadNow = true;
//    }
//
//    if ( doLoadNow )
//    {
//        setTimeout( WE_QuizResults_LoadWidget, delayMs, productsEl );
//    }
//    else
//    {
//        function WE_QuizResults_WaitForApiInterval( )
//        {
//            WE_QuizResults_WaitForApiTick( productsEl, intervalRef, attempts );
//        }
//        intervalRef[ 0 ] = setInterval( WE_QuizResults_WaitForApiInterval, 100 );
//    }
//}

function WE_QuizResults_EnhanceECCards( )
{
    var productsEl = null;
    var cards      = null;
    var i          = 0;
    var card       = null;
    var removeBtn  = null;
    var addBackBtn = null;
    var saveEl     = null;
    var reasonBtn  = null;
    var price      = 0;
    var oldPrice   = 0;
    var pct        = 0;
    var mainPriceEl = null;
    var ecPriceEl   = null;
    var dataString     = "";
    var data           = null;
    var priceEl        = null;
    var oldPriceEl     = null;
    var infoContainer  = null;
    var enhancedCount  = 0;
    var sparkleSvg     = "<svg class=\"we-onboarding-quiz-results-sparkle\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z\"></path><path d=\"M20 3v4\"></path><path d=\"M22 5h-4\"></path><path d=\"M4 17v2\"></path><path d=\"M5 18H3\"></path></svg>";

    productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );
    if ( productsEl )
    {
        cards = productsEl.querySelectorAll( ".product-grid__product-card, .ec-product-card, .product-card" );
        for ( i = 0; i < cards.length; i++ )
        {
            card = cards[ i ];
            if ( !card.getAttribute( "data-variant-id" ) && !card.querySelector( "[data-variant-id]" ) )
            {
                dataString = card.getAttribute( "data-product-data" ) || "";
                data = null;
                try
                {
                    if ( dataString )
                    {
                        data = JSON.parse( dataString );
                    }
                    else
                    {
                        data = null;
                    }
                }
                catch ( err )
                {
                    data = null;
                }
                var resolvedVariantId = WE_QuizResults_GetVariantIdFromProductData( data );
                if ( resolvedVariantId )
                {
                    card.setAttribute( "data-variant-id", resolvedVariantId );
                }
                else
                {
                    resolvedVariantId = WE_QuizResults_GetVariantIdFromCardDom( card );
                    if ( resolvedVariantId )
                    {
                        card.setAttribute( "data-variant-id", resolvedVariantId );
                    }
                    else
                    {
                        WE_QuizResults_AttemptResolveVariantIdForCard( card );
                    }
                }
            }
            if ( !card.classList.contains( "we-quiz-card" ) )
            {
                card.classList.add( "we-quiz-card" );
                enhancedCount++;
            }

            if ( !card.querySelector( ".we-quiz-card__remove" ) )
            {
                removeBtn = document.createElement( "button" );
                removeBtn.setAttribute( "type", "button" );
                removeBtn.setAttribute( "class", "we-quiz-card__remove" );
                removeBtn.setAttribute( "aria-label", "Remove product" );
                removeBtn.textContent = "×";
                card.appendChild( removeBtn );
            }

            if ( !card.querySelector( ".we-quiz-card__add-back" ) )
            {
                addBackBtn = document.createElement( "button" );
                addBackBtn.setAttribute( "type", "button" );
                addBackBtn.setAttribute( "class", "we-quiz-card__add-back" );
                addBackBtn.setAttribute( "aria-label", "Add product back" );
                addBackBtn.setAttribute( "hidden", "hidden" );
                addBackBtn.innerHTML = "<span class=\"we-quiz-card__add-back-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-rotate-ccw\"><path d=\"M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8\"></path><path d=\"M3 3v5h5\"></path></svg></span><span>Add back</span>";
                card.appendChild( addBackBtn );
            }

            var productDataString = card.getAttribute( "data-product-data" ) || "";

            saveEl = card.querySelector( ".we-quiz-card__save" ) || null;
            price = 0;
            oldPrice = 0;
            dataString = productDataString;
            data = null;
            try
            {
                if ( dataString )
                {
                    data = JSON.parse( dataString );
                }
                else
                {
                    data = null;
                }
            }
            catch ( err )
            {
                data = null;
            }
            if ( data && data.attributes )
            {
                price = WE_ParseMoneyValue( data.attributes.price );
                oldPrice = WE_ParseMoneyValue( data.attributes.price_old );
            }
            if ( price <= 0 )
            {
                priceEl = card.querySelector( ".product-card__price__discounted, .ec-product-regular-price" );
                oldPriceEl = card.querySelector( ".product-card__price__full, .ec-product-compare-price, [data-compare-at-price]" );
                if ( priceEl )
                {
                    price = WE_ParseMoneyValue( priceEl.textContent || priceEl.getAttribute( "data-product-price" ) || "" );
                }
                if ( oldPriceEl )
                {
                    oldPrice = WE_ParseMoneyValue( oldPriceEl.textContent || oldPriceEl.getAttribute( "data-compare-at-price" ) || "" );
                }
            }
            if ( oldPrice <= 0 )
            {
                oldPrice = price;
            }
            pct = ( oldPrice > price && oldPrice > 0 ) ? Math.round( ( ( oldPrice - price ) / oldPrice ) * 100 ) : 0;
            if ( !saveEl )
            {
                saveEl = document.createElement( "span" );
                saveEl.className = "we-quiz-card__save";
                saveEl.textContent = "Save " + pct + "%";
                mainPriceEl = card.querySelector( ".product-card__main-price" );
                if ( mainPriceEl )
                {
                    mainPriceEl.appendChild( saveEl );
                }
                else
                {
                    infoContainer = card.querySelector( ".product-card__info-container, a[href].product-card__info-container, .ec-product-info" );
                    if ( infoContainer )
                    {
                        infoContainer.appendChild( saveEl );
                    }
                    else
                    {
                        card.appendChild( saveEl );
                    }
                }
            }
            else
            {
                saveEl.textContent = "Save " + pct + "%";
            }

            mainPriceEl = card.querySelector( ".product-card__main-price" );
            if ( mainPriceEl && saveEl.parentNode != mainPriceEl )
            {
                mainPriceEl.appendChild( saveEl );
            }
            else if ( !mainPriceEl )
            {
                ecPriceEl = card.querySelector( ".ec-product-price" );
                if ( ecPriceEl && saveEl.parentNode != ecPriceEl )
                {
                    ecPriceEl.appendChild( saveEl );
                }
            }

            if ( pct <= 0 )
            {
                saveEl.style.display = "none";
            }
            else
            {
                saveEl.style.display = "";
            }

            if ( !card.querySelector( ".we-quiz-card__reason" ) )
            {
                reasonBtn = document.createElement( "button" );
                reasonBtn.setAttribute( "type", "button" );
                reasonBtn.setAttribute( "class", "we-quiz-card__reason" );
                reasonBtn.setAttribute( "aria-expanded", "false" );
                reasonBtn.innerHTML = sparkleSvg + "<span>Picked for you – see why</span>";
                infoContainer = card.querySelector( ".product-card__info-container, a[href].product-card__info-container, .ec-product-info" );
                if ( infoContainer )
                {
                    infoContainer.appendChild( reasonBtn );
                }
                else
                {
                    card.insertBefore( reasonBtn, card.querySelector( ".we-quiz-card__remove" ) || null );
                    if ( !reasonBtn.parentNode )
                    {
                        card.appendChild( reasonBtn );
                    }
                }
            }
        }
        if ( productsEl && enhancedCount > 0 )
        {
            if ( !productsEl._weQuizResultsRevealAt || Date.now( ) >= productsEl._weQuizResultsRevealAt )
            {
                productsEl.classList.add( "we-onboarding-quiz-results-products--visible" );
            }
        }
        WE_QuizResults_ForceLoadWidgetImages( productsEl );
    }
    WE_QuizResults_PopulatePlaceholderImages( );
}

function WE_QuizResults_PlaceholderPollTick( )
{
    WE_QuizResults_PopulatePlaceholderImages( );
}

function WE_QuizResults_PlaceholderPollStop( pollId )
{
    clearInterval( pollId );
}

function WE_QuizResults_GetFirstUrlFromSrcset( srcsetValue )
{
    var out = "";
    var first = "";

    if ( srcsetValue )
    {
        first = srcsetValue.split( "," )[ 0 ];
        first = first.trim( );
        if ( first.indexOf( " " ) > -1 )
        {
            first = first.split( " " )[ 0 ];
        }
        out = first;
    }

    return out;
}

function WE_QuizResults_GetMainImageUrl( imgEl )
{
    var url = "";
    var out = "";
    if ( imgEl )
    {
        var dataSrc = "";
        var dataLazySrc = "";
        var srcset = "";

        dataSrc = imgEl.getAttribute( "data-src" ) || "";
        dataLazySrc = imgEl.getAttribute( "data-lazy-src" ) || "";
        srcset = imgEl.getAttribute( "data-srcset" ) || imgEl.getAttribute( "srcset" ) || "";

        if ( dataSrc )
        {
            url = dataSrc;
        }
        else if ( dataLazySrc )
        {
            url = dataLazySrc;
        }
        else if ( srcset )
        {
            url = WE_QuizResults_GetFirstUrlFromSrcset( srcset );
        }
        else
        {
            url = imgEl.getAttribute( "src" ) || ( imgEl.currentSrc || "" ) || "";
        }
    }
    if ( url && url.indexOf( "data:" ) != 0 )
    {
        out = url;
    }
    return out;
}

function WE_QuizResults_PopulatePlaceholderImages( )
{
    const mainImgSel = ".we-quiz-card__image-img, .ec-product-image-container img, .product-card__image img, .product-card__image__img, [id=\"product-card-image-container\"] img";
    var productsEl   = document.querySelector( ".we-onboarding-quiz-results-products" );
    var placeholders = document.querySelectorAll( ".we-onboarding-quiz-custom-picked-product-placeholder" );
    var rawCards     = null;
    var card         = null;
    var imgEl        = null;
    var url          = "";
    var i            = 0;
    var ph           = null;
    var img          = null;
    var dataString   = "";
    var dataObj      = null;
    var dataImg      = "";
    var featureImageNode = null;

    if ( productsEl && placeholders.length != 0 )
    {
        rawCards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );
        for ( i = 0; i < placeholders.length; i++ )
        {
            ph = placeholders[ i ];
            if ( i >= rawCards.length )
            {
                ph.innerHTML = "";
                continue;
            }
            card = rawCards[ i ];
            imgEl = card.querySelector( mainImgSel );
            url = WE_QuizResults_GetMainImageUrl( imgEl );
            if ( !url )
            {
                dataString = card.getAttribute( "data-product-data" ) || "";
                dataObj = null;
                dataImg = "";
                try
                {
                    dataObj = dataString ? JSON.parse( dataString ) : null;
                }
                catch ( err )
                {
                    dataObj = null;
                }
                if ( dataObj && dataObj.attributes )
                {
                    dataImg = dataObj.attributes.image_link || dataObj.attributes.image || "";
                }
                if ( !dataImg && dataObj )
                {
                    dataImg = dataObj.image_link || dataObj.image || "";
                }
                url = dataImg || "";
            }
            if ( !url )
            {
                featureImageNode = card.querySelector( "[data-key=\"feature_image\"]" );
                if ( featureImageNode )
                {
                    url = featureImageNode.getAttribute( "data-value" ) || featureImageNode.getAttribute( "src" ) || featureImageNode.getAttribute( "data-src" ) || featureImageNode.getAttribute( "data-lazy-src" ) || "";
                }
            }
            if ( !url )
            {
                continue;
            }
            img = ph.querySelector( "img" );
            if ( img && ( img.getAttribute( "src" ) || "" ) == url )
            {
                continue;
            }
            ph.innerHTML = "";
            img = document.createElement( "img" );
            img.setAttribute( "src", url );
            img.setAttribute( "alt", "" );
            img.setAttribute( "loading", "lazy" );
            ph.appendChild( img );
        }
    }
}

function WE_QuizResults_ForceLoadWidgetImages( productsEl )
{
    var cards      = [];
    var imgEl      = null;
    var dataSrc    = "";
    var src        = "";
    var i          = 0;
    var mainImgSel = ".we-quiz-card__image-img, .ec-product-image-container img, .product-card__image img, .product-card__image__img, [id=\"product-card-image-container\"] img";

    if ( productsEl )
    {
        cards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );
        for ( i = 0; i < cards.length; i++ )
        {
            imgEl = cards[ i ].querySelector( mainImgSel );
            if ( !imgEl )
            {
                continue;
            }
            var dataLazySrc = "";
            var srcset = "";

            dataSrc = imgEl.getAttribute( "data-src" ) || "";
            dataLazySrc = imgEl.getAttribute( "data-lazy-src" ) || "";
            srcset = imgEl.getAttribute( "data-srcset" ) || imgEl.getAttribute( "srcset" ) || "";

            if ( !dataSrc && dataLazySrc )
            {
                dataSrc = dataLazySrc;
            }

            if ( !dataSrc && srcset )
            {
                dataSrc = WE_QuizResults_GetFirstUrlFromSrcset( srcset );
            }
            src = imgEl.getAttribute( "src" ) || "";

            if ( dataSrc && src != dataSrc )
            {
                imgEl.setAttribute( "loading", "eager" );
                imgEl.setAttribute( "src", dataSrc );
            }
            else if ( src && src.indexOf( "http" ) == 0 && imgEl.naturalWidth == 0 )
            {
                imgEl.setAttribute( "loading", "eager" );
                imgEl.removeAttribute( "src" );
                imgEl.setAttribute( "src", src );
            }
        }
    }
}

function WE_QuizResults_GetCardVariantId( card )
{
    var variantId = "";

    if ( card )
    {
        variantId = card.getAttribute( "data-variant-id" ) || "";
        if ( !variantId )
        {
            variantId = ( card.querySelector( "[data-variant-id]" ) && card.querySelector( "[data-variant-id]" ).getAttribute( "data-variant-id" ) ) || "";
        }
    }

    return variantId;
}

function WE_QuizResults_GetVariantIdFromProductData( data )
{
    var variantId = "";

    if ( data )
    {
        variantId = data.variantId || data.variant_id || "";

        if ( !variantId && data.attributes )
        {
            variantId = data.attributes.variantId || data.attributes.variant_id || "";
        }

        if ( !variantId && data.variant )
        {
            variantId = data.variant.id || data.variant.variantId || data.variant.variant_id || "";
        }

        if ( !variantId && data.variants )
        {
            if ( data.variants.length > 0 )
            {
                variantId = data.variants[ 0 ].id || data.variants[ 0 ].variantId || data.variants[ 0 ].variant_id || "";
            }
        }

        if ( !variantId && data.attributes && data.attributes.variants )
        {
            if ( data.attributes.variants.length > 0 )
            {
                variantId = data.attributes.variants[ 0 ].id || data.attributes.variants[ 0 ].variantId || data.attributes.variants[ 0 ].variant_id || "";
            }
        }

        if ( !variantId && data.attributes && data.attributes.variant )
        {
            variantId = data.attributes.variant.id || data.attributes.variant.variantId || data.attributes.variant.variant_id || "";
        }
    }

    return variantId;
}

function WE_QuizResults_GetVariantIdFromCardDom( card )
{
    var variantId = "";

    if ( card )
    {
        var dataEls = null;
        var i = 0;
        var el = null;
        var key = "";
        var value = "";

        dataEls = card.querySelectorAll( "[data-key]" );

        for ( i = 0; i < dataEls.length; i++ )
        {
            el = dataEls[ i ];
            key = el.getAttribute( "data-key" ) || "";

            if ( key == "variants.[0].id" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key == "variants[0].id" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key == "variants.[0].variantId" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key == "variants[0].variantId" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key == "variantId" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key == "variant_id" )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
            else if ( key.indexOf( "variants" ) >= 0 && ( key.indexOf( ".id" ) >= 0 || key.indexOf( "variant_id" ) >= 0 || key.indexOf( "variantId" ) >= 0 ) )
            {
                value = el.getAttribute( "data-value" ) || el.textContent || "";
                variantId = String( value ).trim( );
                break;
            }
        }
    }

    return variantId;
}

function WE_QuizResults_GetProductHandleFromCard( card )
{
    var handle = "";
    var linkEl = null;
    var href   = "";
    var match  = null;
    var handleEl = null;
    var keyValue = "";

    if ( card )
    {
        linkEl = card.querySelector( "a[href*=\"/products/\"]" );
        if ( linkEl )
        {
            href = linkEl.getAttribute( "href" ) || "";
            match = href.match( /\/products\/([^/?]+)/ );
            if ( match && match[ 1 ] )
            {
                handle = match[ 1 ];
            }
        }

        if ( !handle )
        {
            handleEl = card.querySelector( '[data-key="handle"], [data-key="product.handle"], [data-key="productHandle"]' );
            if ( handleEl )
            {
                keyValue = handleEl.getAttribute( "data-value" ) || handleEl.textContent || "";
                handle = keyValue.trim( );
            }
        }
    }

    return handle;
}

function WE_QuizResults_GetCardRegularPriceValue( card )
{
    var priceVal = "";
    var priceEl  = null;

    if ( card )
    {
        priceEl = card.querySelector( "[data-key=\"variants.[0].price\"], .ec-product-regular-price, #product-card-regular-price" );
        if ( priceEl )
        {
            priceVal = priceEl.getAttribute( "data-value" ) || priceEl.textContent || "";
        }
        else
        {
            priceEl = card.querySelector( ".product-card__price__discounted, .ec-product-price" );
            if ( priceEl )
            {
                priceVal = priceEl.textContent || "";
            }
        }
    }

    return WE_ParseMoneyValue( priceVal );
}

function WE_QuizResults_QueueEnhanceAfterVariantResolution( )
{
    var productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );
    if ( productsEl && productsEl._weQuizResultsVariantResolveEnhanceQueued != true )
    {
        productsEl._weQuizResultsVariantResolveEnhanceQueued = true;
        WE_QuizResults_RunVariantResolveEnhanceTick( );
    }
}

function WE_QuizResults_RunVariantResolveEnhanceTick( )
{
    var productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );
    if ( productsEl )
    {
        productsEl._weQuizResultsVariantResolveEnhanceQueued = false;
    }

    WE_QuizResults_EnhanceECCards( );
    WE_QuizResults_RecalculateFooterUI( );
}

async function WE_QuizResults_AttemptResolveVariantIdForCard( card )
{
    var handle = "";
    var regularPrice = 0;
    var productsJson = null;
    var variants = null;
    var variant = null;
    var variantId = "";
    var i = 0;

    if ( !card )
    {
        return false;
    }

    if ( card._weQuizResultsVariantResolveStarted == true )
    {
        return false;
    }

    if ( card.getAttribute( "data-variant-id" ) )
    {
        return false;
    }

    card._weQuizResultsVariantResolveStarted = true;

    handle = WE_QuizResults_GetProductHandleFromCard( card );
    if ( !handle )
    {
        return false;
    }

    regularPrice = WE_QuizResults_GetCardRegularPriceValue( card );

    try
    {
        var response = await fetch( "/products/" + handle + ".js" );
        productsJson = await response.json( );
    }
    catch ( err )
    {
        productsJson = null;
    }

    if ( !productsJson || !productsJson.variants )
    {
        return false;
    }

    variants = productsJson.variants;

    for ( i = 0; i < variants.length; i++ )
    {
        if ( variants[ i ].id )
        {
            if ( regularPrice > 0 )
            {
                if ( WE_ParseMoneyValue( variants[ i ].price ) == regularPrice )
                {
                    variant = variants[ i ];
                    break;
                }
            }
        }
    }

    if ( !variant && variants.length > 0 )
    {
        variant = variants[ 0 ];
    }

    if ( variant && variant.id )
    {
        variantId = String( variant.id );
        card.setAttribute( "data-variant-id", variantId );
        WE_QuizResults_QueueEnhanceAfterVariantResolution( );
        return true;
    }

    return false;
}

function WE_QuizResults_GetImagesCacheKeyName( )
{
    return LOCALSTORAGE_KEY_NAME + "_results_images_cache_v1";
}

function WE_QuizResults_SaveCachedProductImages( productsEl )
{
    var cacheKey  = "";
    var cached     = null;
    var images     = {};
    var resolvedCount = 0;
    var cards      = null;
    var card       = null;
    var imgEl      = null;
    var variantId  = "";
    var url        = "";
    var mainImgSel = ".we-quiz-card__image-img, .ec-product-image-container img, .product-card__image img, .product-card__image__img, [id=\"product-card-image-container\"] img";
    var i          = 0;

    if ( productsEl && !productsEl._weQuizResultsImagesCacheSaved )
    {
        cards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );
        for ( i = 0; i < cards.length; i++ )
        {
            card = cards[ i ];
            variantId = WE_QuizResults_GetCardVariantId( card );
            if ( !variantId )
            {
                continue;
            }

            imgEl = card.querySelector( mainImgSel );
            if ( !imgEl )
            {
                continue;
            }

            url = WE_QuizResults_GetMainImageUrl( imgEl );
            if ( url && url.indexOf( "data:" ) != 0 && url != "" )
            {
                images[ variantId ] = url;
                resolvedCount++;
            }
        }

        if ( resolvedCount > 0 )
        {
            cacheKey = WE_QuizResults_GetImagesCacheKeyName( );
            cached = {
                "imagesByVariant" : images
            };
            window.localStorage.setItem( cacheKey, JSON.stringify( cached ) );
            productsEl._weQuizResultsImagesCacheSaved = true;
        }
    }
}

function WE_QuizResults_ApplyCachedProductImages( productsEl )
{
    var cacheKey = "";
    var cachedStr = "";
    var cached = null;
    var imagesByVariant = null;
    var imagesByProductKey = null;
    var imagesByIndex = null;
    var cards      = null;
    var card       = null;
    var imgEl      = null;
    var variantId  = "";
    var productKey = "";
    var url        = "";
    var src        = "";
    var mainImgSel = ".we-quiz-card__image-img, .ec-product-image-container img, .product-card__image img, .product-card__image__img, [id=\"product-card-image-container\"] img";
    var i          = 0;
    var appliedAny = false;

    if ( productsEl )
    {
        WE_QuizResults_BuildImagesCacheFromWidgetHtmlIfNeeded( );

        cacheKey = WE_QuizResults_GetImagesCacheKeyName( );
        cachedStr = window.localStorage.getItem( cacheKey );
        if ( cachedStr )
        {
            try
            {
                cached = JSON.parse( cachedStr );
            }
            catch ( e )
            {
                cached = null;
            }
        }

        if ( cached && cached.imagesByVariant )
        {
            imagesByVariant = cached.imagesByVariant;
        }

        if ( cached && cached.imagesByProductKey )
        {
            imagesByProductKey = cached.imagesByProductKey;
        }

        if ( cached && cached.imagesByIndex )
        {
            imagesByIndex = cached.imagesByIndex;
        }

        if ( cached )
        {
            cards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );
            for ( i = 0; i < cards.length; i++ )
            {
                card = cards[ i ];
                variantId = WE_QuizResults_GetCardVariantId( card );
                productKey = WE_QuizResults_GetProductKeyForCard( card );

                url = "";

                if ( imagesByProductKey && productKey )
                {
                    url = imagesByProductKey[ productKey ];
                }

                if ( !url && imagesByVariant && variantId )
                {
                    url = imagesByVariant[ variantId ];
                }

                if ( !url && imagesByIndex && ( i < imagesByIndex.length ) )
                {
                    url = imagesByIndex[ i ];
                }

                if ( !url )
                {
                    continue;
                }

                imgEl = card.querySelector( mainImgSel );
                if ( !imgEl )
                {
                    continue;
                }

                src = imgEl.getAttribute( "src" ) || "";
                if ( !src || ( src.indexOf( "data:" ) == 0 ) || src != url )
                {
                    imgEl.setAttribute( "loading", "eager" );
                    imgEl.setAttribute( "src", url );
                    appliedAny = true;
                }
            }
        }
    }

    if ( productsEl && appliedAny )
    {
        productsEl._weQuizResultsImagesAppliedCached = true;
    }
}

function WE_QuizResults_GetVariantCacheKeyName( )
{
    return LOCALSTORAGE_KEY_NAME + "_results_variant_cache_v1";
}

function WE_QuizResults_SaveVariantIdCacheFromWidgetHtmlIfNeeded( )
{
    var variantCacheKey = "";
    var variantCacheStr = "";
    var variantCache = null;
    var shouldBuild = true;

    variantCacheKey = WE_QuizResults_GetVariantCacheKeyName( );
    variantCacheStr = window.localStorage.getItem( variantCacheKey );
    if ( variantCacheStr )
    {
        try
        {
            variantCache = JSON.parse( variantCacheStr );
        }
        catch ( e )
        {
            variantCache = null;
        }

        if ( variantCache && variantCache.variantByProductKey && Object.keys( variantCache.variantByProductKey ).length > 0 )
        {
            shouldBuild = false;
        }
    }

    var widgetCacheKey = LOCALSTORAGE_KEY_NAME + "_results_cache_v1";
    var widgetCacheStr = window.localStorage.getItem( widgetCacheKey );
    var hasWidgetCache = false;
    if ( widgetCacheStr )
    {
        hasWidgetCache = true;
    }

    if ( shouldBuild && hasWidgetCache )
    {
        var widgetCache = null;
        try
        {
            widgetCache = JSON.parse( widgetCacheStr );
        }
        catch ( e )
        {
            widgetCache = null;
        }

        if ( widgetCache && widgetCache.widgetHtml )
        {
            var parser = new DOMParser( );
            var doc = parser.parseFromString( widgetCache.widgetHtml, "text/html" );
            var productCards = doc.querySelectorAll( ".ec-product-card, .product-grid__product-card .ec-product-card, .product-grid__product-card, .we-quiz-card" );

            var variantByProductKey = {};
            var i = 0;

            for ( i = 0; i < productCards.length; i++ )
            {
                var card = productCards[ i ];
                var productKey = WE_QuizResults_GetProductKeyForCard( card );
                var variantId = "";
                var idEl = null;

                if ( productKey )
                {
                    idEl = card.querySelector( '[data-key="variants.[0].id"], [data-key="variants[0].id"], [data-key="variant_id"], [data-key="variantId"], [data-key="variants[0].variantId"], [data-key="variants.[0].variantId"]' );
                    if ( idEl )
                    {
                        variantId = ( idEl.getAttribute( "data-value" ) || idEl.textContent || "" ).trim( );
                    }

                    if ( variantId )
                    {
                        variantByProductKey[ productKey ] = variantId;
                    }
                }
            }

            var payload = {
                "variantByProductKey" : variantByProductKey
            };
            window.localStorage.setItem( variantCacheKey, JSON.stringify( payload ) );
        }
    }
}

function WE_QuizResults_ApplyCachedVariantIds( productsEl )
{
    var variantCacheKey = "";
    var variantCacheStr = "";
    var variantCache = null;
    var variantByProductKey = null;
    var cards = null;
    var i = 0;
    var card = null;
    var productKey = "";
    var variantId = "";

    var canApply = false;

    if ( productsEl && !productsEl._weQuizResultsVariantIdsApplied )
    {
        canApply = true;
    }

    if ( canApply )
    {
        WE_QuizResults_SaveVariantIdCacheFromWidgetHtmlIfNeeded( );

        variantCacheKey = WE_QuizResults_GetVariantCacheKeyName( );
        variantCacheStr = window.localStorage.getItem( variantCacheKey );
        if ( variantCacheStr )
        {
            try
            {
                variantCache = JSON.parse( variantCacheStr );
            }
            catch ( e )
            {
                variantCache = null;
            }
        }

        if ( variantCache && variantCache.variantByProductKey )
        {
            variantByProductKey = variantCache.variantByProductKey;
            cards = productsEl.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );

            for ( i = 0; i < cards.length; i++ )
            {
                card = cards[ i ];
                if ( card.getAttribute( "data-variant-id" ) || card.querySelector( "[data-variant-id]" ) )
                {
                    continue;
                }

                productKey = WE_QuizResults_GetProductKeyForCard( card );
                if ( !productKey )
                {
                    continue;
                }

                variantId = variantByProductKey[ productKey ];
                if ( variantId )
                {
                    card.setAttribute( "data-variant-id", variantId );
                }
            }
        }

        productsEl._weQuizResultsVariantIdsApplied = true;
    }
}

function WE_QuizResults_GetProductKeyForCard( card )
{
    var vendorEl = null;
    var titleEl = null;
    var vendor = "";
    var title = "";
    var key = "";

    if ( card )
    {
        vendorEl = card.querySelector( ".ec-product-vendor, .product-card__brand, .we-quiz-card__vendor, [data-key=\"vendor\"]" );
        if ( vendorEl )
        {
            vendor = ( vendorEl.textContent || "" ).trim( );
        }

        titleEl = card.querySelector( ".ec-product-title, .product-card__title, .we-quiz-card__title, [data-key=\"title\"]" );
        if ( titleEl )
        {
            title = ( titleEl.textContent || "" ).trim( );
        }

        if ( vendor && title )
        {
            key = vendor + "::" + title;
        }
    }

    return key;
}

function WE_QuizResults_BuildImagesCacheFromWidgetHtmlIfNeeded( )
{
    var imagesCacheKey = "";
    var imagesCacheStr = "";
    var imagesCache = null;
    var cachedOk = false;
    var shouldBuild = false;

    imagesCacheKey = WE_QuizResults_GetImagesCacheKeyName( );
    imagesCacheStr = window.localStorage.getItem( imagesCacheKey );
    if ( imagesCacheStr )
    {
        try
        {
            imagesCache = JSON.parse( imagesCacheStr );
        }
        catch ( e )
        {
            imagesCache = null;
        }

        if ( imagesCache && imagesCache.imagesByProductKey && imagesCache.imagesByIndex && imagesCache.imagesByIndex.length > 0 )
        {
            cachedOk = true;
        }
    }

    if ( cachedOk )
    {
        shouldBuild = false;
    }
    else
    {
        shouldBuild = true;
    }

    if ( shouldBuild )
    {
        var widgetCacheKey = LOCALSTORAGE_KEY_NAME + "_results_cache_v1";
        var widgetCacheStr = window.localStorage.getItem( widgetCacheKey );
        if ( widgetCacheStr )
        {
            var widgetCache = null;
            try
            {
                widgetCache = JSON.parse( widgetCacheStr );
            }
            catch ( e )
            {
                widgetCache = null;
            }

            if ( widgetCache && widgetCache.widgetHtml )
            {
                var parser = new DOMParser( );
                var doc = parser.parseFromString( widgetCache.widgetHtml, "text/html" );
                var productEls = doc.querySelectorAll( ".ec-product-card, .product-grid__product-card, .we-quiz-card" );

                var imagesByProductKey = {};
                var imagesByIndex = [];
                var i = 0;

                for ( i = 0; i < productEls.length; i++ )
                {
                    var card = productEls[ i ];
                    var imgEl = card.querySelector( ".ec-product-image-container img, img" );
                    var url = "";
                    var key = "";

                    if ( imgEl )
                    {
                        url = imgEl.getAttribute( "src" ) || "";
                        url = url.trim( );
                    }

                    key = WE_QuizResults_GetProductKeyForCard( card );

                    if ( url )
                    {
                        imagesByIndex.push( url );
                        if ( key )
                        {
                            imagesByProductKey[ key ] = url;
                        }
                    }
                }

                var payload = {
                    "imagesByVariant" : { },
                    "imagesByProductKey" : imagesByProductKey,
                    "imagesByIndex" : imagesByIndex
                };

                window.localStorage.setItem( imagesCacheKey, JSON.stringify( payload ) );
            }
        }
    }
}

function WE_QuizResults_GetActiveCards( )
{
    var cards      = null;
    var ecCards    = null;
    var active     = [];
    var i          = 0;
    var card       = null;
    var productsEl = null;

    cards = document.querySelectorAll( ".we-quiz-card" );
    for ( i = 0; i < cards.length; i++ )
    {
        if ( cards[ i ].classList.contains( "we-quiz-card--removed" ) == false && active.indexOf( cards[ i ] ) == -1 )
        {
            active.push( cards[ i ] );
        }
    }

    productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );
    if ( productsEl )
    {
        ecCards = productsEl.querySelectorAll( ".product-grid__product-card, .ec-product-card, .product-card" );
        for ( i = 0; i < ecCards.length; i++ )
        {
            card = ecCards[ i ];
            if ( !card.classList.contains( "we-quiz-card" ) && !card.classList.contains( "we-quiz-card--removed" ) && active.indexOf( card ) == -1 )
            {
                active.push( card );
            }
        }
    }

    return active;
}

function WE_QuizResults_UpdateItemCountUI( activeCount )
{
    var countEl = null;

    countEl = document.querySelector( ".we-onboarding-quiz-results-item-count" );

    if ( countEl )
    {
        countEl.textContent = String( activeCount );
    }
}

function WE_QuizResults_UpdateTotalsUI( total, save )
{
    var totalEl = null;
    var saveEl  = null;

    totalEl = document.querySelector( ".we-onboarding-quiz-results-total-amount" );
    saveEl  = document.querySelector( ".we-onboarding-quiz-results-save-amount" );

    if ( totalEl )
    {
        totalEl.textContent = "£" + total.toFixed( 2 );
    }

    if ( saveEl )
    {
        saveEl.textContent = "£" + save.toFixed( 2 );
    }
}

function WE_QuizResults_RecalculateFooterUI( )
{
    var activeCards = [];
    var total       = 0;
    var save        = 0;
    var i           = 0;
    var card        = null;
    var dataString  = "";
    var data        = null;
    var price       = 0;
    var oldPrice    = 0;
    var priceEl     = null;
    var oldPriceEl  = null;

    activeCards = WE_QuizResults_GetActiveCards( );

    for ( i = 0; i < activeCards.length; i++ )
    {
        card       = activeCards[ i ];
        dataString = card.getAttribute( "data-product-data" ) || "";
        data       = null;
        price      = 0;
        oldPrice   = 0;

        if ( dataString )
        {
            try
            {
                data = JSON.parse( dataString );
            }
            catch ( err )
            {
                data = null;
            }

            if ( data && data.attributes )
            {
                price    = WE_ParseMoneyValue( data.attributes.price );
                oldPrice = WE_ParseMoneyValue( data.attributes.price_old );
            }
        }

        if ( price <= 0 )
        {
            priceEl    = card.querySelector( ".product-card__price__discounted, .ec-product-price" );
            oldPriceEl = card.querySelector( ".product-card__price__full" );
            if ( priceEl )
            {
                price = WE_ParseMoneyValue( priceEl.textContent || "" );
            }
            if ( price <= 0 )
            {
                priceEl = card.querySelector( "[data-product-price]" );
                if ( priceEl )
                {
                    price = WE_ParseMoneyValue( priceEl.getAttribute( "data-product-price" ) || "" );
                }
            }
            if ( oldPriceEl )
            {
                oldPrice = WE_ParseMoneyValue( oldPriceEl.textContent || "" );
            }
            if ( oldPrice <= 0 )
            {
                oldPriceEl = card.querySelector( "[data-compare-at-price]" );
                if ( oldPriceEl )
                {
                    oldPrice = WE_ParseMoneyValue( oldPriceEl.getAttribute( "data-compare-at-price" ) || "" );
                }
            }
            if ( oldPrice <= 0 )
            {
                oldPrice = price;
            }
        }

        if ( price > 0 )
        {
            total += price;
            if ( oldPrice > price )
            {
                save += ( oldPrice - price );
            }
        }
    }

    WE_QuizResults_UpdateItemCountUI( activeCards.length );
    WE_QuizResults_UpdateTotalsUI( total, save );
}

function WE_QuizResults_SetAddToCartLoading( button, isLoading )
{
    if ( isLoading )
    {
        button.setAttribute( "aria-busy", "true" );
        button.setAttribute( "disabled", "disabled" );
        button.classList.add( "is-loading" );
    }
    else
    {
        button.removeAttribute( "aria-busy" );
        button.removeAttribute( "disabled" );
        button.classList.remove( "is-loading" );
    }
}

function WE_QuizResults_SetAddToCartMessage( button, message )
{
    var original = "";

    original = button.getAttribute( "data-original-text" ) || "";

    if ( original == "" )
    {
        button.setAttribute( "data-original-text", button.textContent || "" );
    }

    button.textContent = message;
}

function WE_QuizResults_ResetAddToCartMessage( button )
{
    var original = "";

    original = button.getAttribute( "data-original-text" ) || "";

    if ( original )
    {
        button.textContent = original;
    }
}

function WE_QuizResults_BuildActiveVariantItems( )
{
    var activeCards = [];
    var items       = [];
    var i           = 0;
    var card        = null;
    var variantId   = "";
    var sellingPlan = null;
    var spEl        = null;

    activeCards = WE_QuizResults_GetActiveCards( );

    for ( i = 0; i < activeCards.length; i++ )
    {
        card      = activeCards[ i ];
        variantId = card.getAttribute( "data-variant-id" ) || "";
        sellingPlan = null;
        spEl = card.querySelector( "[data-membership-selling-plan-id], [data-selling-plan-id]" );
        if ( spEl )
        {
            sellingPlan = spEl.getAttribute( "data-membership-selling-plan-id" ) || spEl.getAttribute( "data-selling-plan-id" ) || "";
            if ( sellingPlan == "" )
            {
                sellingPlan = null;
            }
        }

        if ( variantId )
        {
            var item = { "id": variantId, "quantity": 1, "_card": card };
            if ( sellingPlan )
            {
                item.selling_plan = sellingPlan;
            }
            items.push( item );
        }
    }

    return items;
}

function WE_QuizResults_FindVariantById( variants, variantId )
{
    var i   = 0;
    var out = null;

    for ( i = 0; i < variants.length; i++ )
    {
        if ( String( variants[ i ].id ) == String( variantId ) )
        {
            out = variants[ i ];
            break;
        }
    }
    return out;
}

async function WE_QuizResults_FetchSellingPlanForVariant( card, variantId )
{
    var link    = null;
    var match   = null;
    var handle  = null;
    var product = null;
    var v       = null;
    var spid    = null;
    var result  = null;

    if ( card )
    {
        link = card.querySelector( "a[href*='/products/']" );
        if ( link && link.href )
        {
            match = link.getAttribute( "href" ).match( /\/products\/([^\/\?]+)/ );
            if ( match && match[ 1 ] )
            {
                handle = match[ 1 ];
                try
                {
                    product = await fetch( "/products/" + handle + ".js" ).then( function WE_QuizResults_FetchProductJson( r ) { return r.json( ); } );
                }
                catch ( err )
                {
                }
                if ( product && product.variants )
                {
                    v = WE_QuizResults_FindVariantById( product.variants, variantId );
                    if ( v && v.selling_plan_allocations && v.selling_plan_allocations.length > 0 )
                    {
                        spid = v.selling_plan_allocations[ 0 ].selling_plan_id;
                    }
                }
                result = spid || null;
            }
        }
    }
    return result;
}

function WE_QuizResults_GetEcSid( )
{
    var sid = null;

    try
    {
        sid = window.localStorage.getItem( "EC_SID" );
    }
    catch ( e )
    {
    }

    return sid;
}

function WE_QuizResults_MapItemToCartItem( it )
{
    var out = { "id": it.id, "quantity": it.quantity };
    var sid = WE_QuizResults_GetEcSid( );

    if ( it.selling_plan )
    {
        out.selling_plan = it.selling_plan;
    }

    out.properties = { "_enhancedcommerce": sid || "" };
    return out;
}

function WE_QuizResults_GetAddToCartLoadingOverlay( )
{
    var el = document.querySelector( ".we-onboarding-quiz-add-to-cart-loading" );
    if ( !el )
    {
        el = document.createElement( "div" );
        el.className = "we-onboarding-quiz-add-to-cart-loading hidden";
        el.setAttribute( "aria-hidden", "true" );
        el.innerHTML = "<div class=\"we-onboarding-quiz-add-to-cart-loading__text-wrap\"><span class=\"we-onboarding-quiz-add-to-cart-loading__text\">Filling up your basket... good things take a moment</span></div><div class=\"we-onboarding-quiz-add-to-cart-loading__circle\"></div>";
        document.body.appendChild( el );
    }
    return el;
}

function WE_QuizResults_ShowAddToCartLoadingOverlay( )
{
    var el = WE_QuizResults_GetAddToCartLoadingOverlay( );
    el.classList.remove( "hidden" );
    el.setAttribute( "aria-hidden", "false" );
}

function WE_QuizResults_HideAddToCartLoadingOverlay( )
{
    var el = document.querySelector( ".we-onboarding-quiz-add-to-cart-loading" );
    if ( el )
    {
        el.classList.add( "hidden" );
        el.setAttribute( "aria-hidden", "true" );
    }
}

async function WE_QuizResults_AddActiveToCart( button )
{
    var items     = [];
    var i         = 0;
    var cartItems = [];
    var response  = null;
    var added     = 0;
    var failed    = 0;

    WE_QuizResults_ShowAddToCartLoadingOverlay( );
    try
    {
        items = WE_QuizResults_BuildActiveVariantItems( );

        WE_QuizResults_SetAddToCartLoading( button, true );

        if ( items.length < 1 )
        {
            WE_QuizResults_SetAddToCartMessage( button, "No products selected" );
            WE_QuizResults_SetAddToCartLoading( button, false );
        }
        else
        {
            WE_QuizResults_SetAddToCartMessage( button, "Adding..." );

            for ( i = 0; i < items.length; i++ )
            {
                if ( !items[ i ].selling_plan && items[ i ]._card )
                {
                    items[ i ].selling_plan = await WE_QuizResults_FetchSellingPlanForVariant( items[ i ]._card, items[ i ].id );
                }
            }

            cartItems = items.map( WE_QuizResults_MapItemToCartItem );
            for ( i = 0; i < cartItems.length; i++ )
            {
                response = await fetch(
                    "/cart/add.js",
                    {
                        "method": "POST",
                        "headers":
                        {
                            "Content-Type": "application/json",
                            "Accept": "application/json"
                        },
                        "body": JSON.stringify( { "items": [ cartItems[ i ] ] } )
                    }
                );
                if ( response.ok )
                {
                    added++;
                }
                else
                {
                    failed++;
                }
            }

            if ( added > 0 )
            {
                document.dispatchEvent(
                    new CustomEvent(
                        "cart:updated",
                        {
                            "detail":
                            {
                                "source": "we-onboarding-quiz-results"
                            }
                        }
                    )
                );
            }

            if ( added > 0 )
            {
                WE_QuizResults_SetAddToCartMessage( button, "Added" );
                if ( failed > 0 )
                {
                    WE_QuizResults_SetAddToCartMessage( button, "Added " + added + ", " + failed + " unavailable" );
                }
                /* Skip slides 21/22: show cart redirect animation then go to cart */
                const cartRedirectSlide = { slideType: "CartRedirect", position: 9999 };
                window._onboardingQuizData.slides.push( cartRedirectSlide );
                const slideIndex = window._onboardingQuizData.slides.length - 1;
                ShowSlide( slideIndex, false );
            }
            else
            {
                WE_QuizResults_SetAddToCartMessage( button, "No items could be added" );
            }

            WE_QuizResults_SetAddToCartLoading( button, false );
        }
    }
    finally
    {
        WE_QuizResults_HideAddToCartLoadingOverlay( );
    }
}

function WE_OnboardingQuizResults_OnClick( e )
{
    var target      = null;
    var removeBtn   = null;
    var addBackBtn  = null;
    var reasonBtn   = null;
    var closeBtn    = null;
    var atcBtn      = null;
    var card        = null;
    var handled     = false;
    var drawer      = null;
    var panel       = null;
    var productLink = null;
    var resultsArea = null;
    var unenhanced  = null;

    target = e.target;

    if ( target && target.closest )
    {
        resultsArea = target.closest( ".we-onboarding-quiz-results-products" );
        if ( resultsArea )
        {
            unenhanced = target.closest( ".product-grid__product-card, .ec-product-card, .product-card" );
            if ( unenhanced && !unenhanced.querySelector( ".we-quiz-card__remove" ) )
            {
                WE_QuizResults_RunEnhanceOnWidgetLoad( );
            }
        }

        removeBtn  = target.closest( ".we-quiz-card__remove" );
        addBackBtn = target.closest( ".we-quiz-card__add-back" );
        reasonBtn  = target.closest( ".we-quiz-card__reason" );
        closeBtn   = target.closest( "[data-we-quiz-drawer-close]" );
        atcBtn     = target.closest( ".we-onboarding-quiz-results-add-to-cart" );

        if ( removeBtn )
        {
            card = removeBtn.closest( ".we-quiz-card" );

            if ( card )
            {
                WE_OnboardingQuizResults_SetQuizCardRemovedState( card, true );
                handled = true;
            }
        }
        else if ( addBackBtn )
        {
            card = addBackBtn.closest( ".we-quiz-card" );

            if ( card )
            {
                WE_OnboardingQuizResults_SetQuizCardRemovedState( card, false );
                handled = true;
            }
        }
        else if ( reasonBtn )
        {
            card = reasonBtn.closest( ".we-quiz-card" );

            if ( card )
            {
                WE_OnboardingQuizResults_OpenDrawer( reasonBtn, card );
                handled = true;
            }
        }
        else if ( closeBtn )
        {
            WE_OnboardingQuizResults_CloseDrawer( );
            handled = true;
        }
        else if ( atcBtn )
        {
            WE_QuizResults_AddActiveToCart( atcBtn );
            handled = true;
        }
        else
        {
            productLink = target.closest( "a[href*='/products/']" );
            if ( productLink )
            {
                card = productLink.closest( ".we-quiz-card" );
                if ( card && card.closest( ".we-onboarding-quiz-results-products" ) )
                {
                    reasonBtn = card.querySelector( ".we-quiz-card__reason" );
                    WE_OnboardingQuizResults_OpenDrawer( reasonBtn || null, card );
                    handled = true;
                }
            }
        }

        if ( !handled )
        {
            drawer = WE_OnboardingQuizResults_GetDrawer( );
            panel  = drawer ? drawer.querySelector( ".we-quiz-drawer__panel" ) : null;

            if ( drawer && panel && drawer.classList.contains( "we-quiz-drawer--open" ) && !panel.contains( target ) )
            {
                WE_OnboardingQuizResults_CloseDrawer( );
                handled = true;
            }
        }
    }

    if ( handled )
    {
        e.preventDefault( );
        e.stopPropagation( );
        WE_QuizResults_RecalculateFooterUI( );
    }
}

function WE_OnboardingQuizResults_OnKeyDown( e )
{
    if ( e.key == "Escape" )
    {
        WE_OnboardingQuizResults_CloseDrawer( );
    }
}

function WE_OnboardingQuiz_HideMobileButtonsOnSlide20( )
{
    var buttons = null;
    var i       = 0;
    var path    = window.location.pathname || "";
    var search  = window.location.search || "";

    if ( path.replace( /\/$/, "" ) == "/pages/welleasy-quiz" && search.indexOf( "slide=20" ) != -1 )
    {
        buttons = document.querySelectorAll( ".we-onboarding-quiz-buttons-mobile" );
        for ( i = 0; i < buttons.length; i++ )
        {
            buttons[ i ].style.display = "none !important";
        }
    }
}

function WE_SetQuizCardRemovedState( card, isRemoved )
{
    var addBack = null;

    addBack = card.querySelector( '.we-quiz-card__add-back' );

    if ( isRemoved )
    {
        card.classList.add( 'we-quiz-card--removed' );
        if ( addBack )
        {
            addBack.hidden = false;
        }
    }
    else
    {
        card.classList.remove( 'we-quiz-card--removed' );
        if ( addBack )
        {
            addBack.hidden = true;
        }
    }
}

function WE_OnQuizCardInteraction( e )
{
    var removeBtn = null;
    var addBackBtn = null;
    var card = null;

    removeBtn  = e.target.closest( '.we-quiz-card__remove' );
    addBackBtn = e.target.closest( '.we-quiz-card__add-back' );

    if ( removeBtn )
    {
        card = removeBtn.closest( '.we-quiz-card' );
        if ( card )
        {
            e.preventDefault( );
            e.stopPropagation( );
            WE_SetQuizCardRemovedState( card, true );
            WE_QuizResults_RecalculateFooterUI( );
        }
    }
    else if ( addBackBtn )
    {
        card = addBackBtn.closest( '.we-quiz-card' );
        if ( card )
        {
            e.preventDefault( );
            e.stopPropagation( );
            WE_SetQuizCardRemovedState( card, false );
            WE_QuizResults_RecalculateFooterUI( );
        }
    }
}

function WE_InitQuizCardRemoveUX( )
{
    document.addEventListener( 'click', WE_OnQuizCardInteraction );
}

function EC_Ruk_StripReviewsWord( )
{
    var snippets = null;

    snippets = document.querySelectorAll( ".ruk_rating_snippet" );

    for ( var i = 0; i < snippets.length; i++ )
    {
        var snippet = null;
        var countEl = null;
        var text    = "";

        snippet = snippets[ i ];
        countEl = snippet.querySelector( ".ruk-rating-snippet-count" );

        if ( countEl )
        {
            text = countEl.textContent || "";

            if ( text.indexOf( " Reviews" ) >= 0 )
            {
                text = text.replace( " Reviews", "" );
            }
            else if ( text.indexOf( " Review" ) >= 0 )
            {
                text = text.replace( " Review", "" );
            }

            countEl.textContent = text;
        }
    }

}


function WE_QuizResults_OnWidgetCardsLoaded( e )
{
    //console.log( "card loaded : ", e.detail );
    var card        = ( e && e.detail && e.detail.card ) || null;
    var productsEl  = document.querySelector( ".we-onboarding-quiz-results-products" );

    if ( productsEl && ( !card || productsEl.contains( card ) ) )
    {
        WE_QuizResults_EnhanceECCards( );
        WE_QuizResults_RecalculateFooterUI( );
    }
}

function WE_QuizResults_OnWidgetCardPricesReady( e )
{
    var card       = ( e && e.detail && e.detail.card ) || null;
    var productsEl = document.querySelector( ".we-onboarding-quiz-results-products" );

    if ( productsEl && ( !card || productsEl.contains( card ) ) )
    {
        WE_QuizResults_RecalculateFooterUI( );
    }
}

function WE_OnboardingQuiz_OnDOMReady( )
{
    document.addEventListener( "click", WE_OnboardingQuizResults_OnClick );
    document.addEventListener( "keydown", WE_OnboardingQuizResults_OnKeyDown );

    window.addEventListener( "enhancedcommerce:card_rendered", WE_QuizResults_OnWidgetCardsLoaded );
    document.addEventListener( "enhancedcommerce:card_prices_ready", WE_QuizResults_OnWidgetCardPricesReady );

    WE_QuizResults_RecalculateFooterUI( );
    WE_OnboardingQuiz_HideMobileButtonsOnSlide20( );
    WE_InitQuizCardRemoveUX( );
    EC_Ruk_StripReviewsWord( );
}

function WE_OnboardingQuiz_InitOnce( )
{
    var shouldRun = WE_OnboardingQuiz_InitOnce._ran != true;

    if ( shouldRun )
    {
        WE_OnboardingQuiz_InitOnce._ran = true;
        WE_OnboardingQuiz_OnDOMReady( );
    }
}

if ( document.readyState == "loading" )
{
    window.addEventListener( "DOMContentLoaded", WE_OnboardingQuiz_InitOnce );
}
else
{
    WE_OnboardingQuiz_InitOnce( );
}

function WE_OnboardingQuiz_OnPageShowBfCache( event )
{
    var quiz                  = null;
    var qp                    = null;
    var targetPosition        = 0;
    var slideIdx              = 0;
    var i                     = 0;
    var slidePosition         = 0;
    var navEntry              = null;
    var isBackNav             = false;
    var fromCartFlag          = null;
    var canHandleBackNav      = false;
    var hasSlideQuery         = false;
    var shouldRedirectToCart  = false;
    var hasValidTarget        = false;

    navEntry = performance.getEntriesByType( "navigation" )[ 0 ];
    isBackNav = ( event.persisted == true ) || ( navEntry && navEntry.type == "back_forward" );

    quiz = document.querySelector( ".we-onboarding-quiz" );
    qp = ParseQP( );
    hasSlideQuery = qp.slide != undefined && qp.slide != "";

    canHandleBackNav =
    (
        quiz &&
        window._onboardingQuizData &&
        window._onboardingQuizData.slides &&
        isBackNav &&
        hasSlideQuery
    );

    if ( canHandleBackNav )
    {
        try
        {
            fromCartFlag = sessionStorage.getItem( "we_checkout_started_from_cart" );
        }
        catch ( e )
        {
            fromCartFlag = null;
        }

        shouldRedirectToCart = fromCartFlag == "1";

        if ( shouldRedirectToCart )
        {
            try
            {
                sessionStorage.removeItem( "we_checkout_started_from_cart" );
            }
            catch ( e )
            {
            }

            window.location.replace( "/cart" );
        }
        else
        {
            targetPosition = parseInt( qp.slide, 10 );
            hasValidTarget = !isNaN( targetPosition );

            if ( hasValidTarget )
            {
                slideIdx = 0;
                for ( i = 0; i < window._onboardingQuizData.slides.length; i++ )
                {
                    slidePosition = parseInt( window._onboardingQuizData.slides[ i ].position, 10 );
                    if ( !isNaN( slidePosition ) && slidePosition == targetPosition )
                    {
                        slideIdx = i;
                        break;
                    }
                }

                ShowSlide( slideIdx, true );
            }
        }
    }
}

window.addEventListener( "pageshow", WE_OnboardingQuiz_OnPageShowBfCache );

window.addEventListener( 'popstate', function WE_OnboardingQuiz_OnPopState( event )
{
    StartOnboardingQuiz( );
} );
